export const enData = `
[global]

Account = Account
AccountNumber = Account number
Accounts = Accounts
Add = Add
AddToQueue = Add to queue
adding = adding...
AddMoreItem = Add more item information
AddMoreVendor = Add more vendor information
AddNewIndicator = Add new
AddNewItem = Add new item
addNewSentence = Add new
AddNewVendor = Add new vendor
AddOtherCosts = Add other costs
Address = Address
Addresses = Addresses
AddLines = Add lines
AddLine = Add line
AltPhone = Alt Phone
Apply = Apply
Assembly = Assembly
Attachment = Attachment
Amount = Amount
Archive = Archive
archived = archived
AsOf = As of
at = at
AsOfDate = As of date
AssignedByQuickBooks = Assigned by QuickBooks
assignedTo = assigned to
Automatic = Automatic
Available = Available

BatchActions = Batch actions
Bill = Bill
BillofMaterials = Bill of Materials
Billing = Billing
Boxes = Boxes

Calendar = Calendar
Cancel = Cancel
Category = Category
Categories = Categories
Checkbox = Checkbox 
City = City
clearOtherCostsTitle = Clear other costs
Columns = Columns
CommentHistory = Comment history
Completed = Completed
Compute = Compute
Customize = Customize
Class = Class
Clear = Clear
clearLinesMessage = You are about to clear data from all line items. Proceed?
clearOtherCostsMessage = You are about to clear data from all other costs. Proceed?
ClearLines = Clear lines
ClearLinesOnDisplayedRows = Clear lines on displayed rows
Close = Close
Closed = Closed
colon = ":"
Contents = Contents
CostBasisAdjustment = Cost basis adjustment
Contact = Contact
Company = Company
Country = Country
CreditAmount = Credit amount
Currency= Currency
CurrentlyUnavailable = currently unavailable
CustomField = Custom field
CustomFields = Custom fields
Customer = Customer

Date = Date
DateSelector = Date selector
Days = Days
Dashboard = Dashboard
Default = Default
DefaultBilling = Default billing
DefaultShipping = Default shipping
DefaultTax = Default tax
Delete = Delete
deleteSelectedRecords = You are about to delete the selected records. Proceed?
deleteRecordMessage = You are about to permanently delete {{objectType}} {{identifier}}. Proceed?
deleteItemRecordMessage = You are about delete item {{identifier}}. Proceed?
Department = Department
Description = Description
Details = Details
Discount = Discount
DiscountAmount = Discount Amt
DiscountPercent = 'Discount %'
Display = Display
Documents = Documents
Done = Done
Download = Download
DropdownLoading = loading...

Edit = Edit
Email = Email
Entered = Entered
endingIn = ending in
Error = Something went wrong.
Example = Example
ExchangeRate = Exchange rate
Expand = Expand
expiring = expiring
ExitConfiguration = Exit configuration

Fax = Fax
FeatureRequests = Feature requests
Fill = Fill
LineItemFillHoverText = Fill all lines with the value on line 1
FirstName = First name
for = for
Footer = Footer
Format = Format
from = from
FromDate = From date
Fulfillment = Fulfillment

Generate = Generate
GeneratePdf = Generate PDF
GeneratePrintLabel = Generate print label
GeneratePurchaseOrders = Generate purchase orders
GlobalSearch = Global search
GoToMerchantTrack = Go to MerchantTrack

Header = Header
Height = Height
History = History
Home = Home

input = input
Inputs = Inputs
Inventory = Inventory
Item = Item

JobDashboard = Job dashboard

Label = Label
LastName = Last name
LeaveThisPage = Are you sure you want to leave this page?
LeaveThisPageHeader = Leave this page?
Line = Line
LineNumber = "Line #"
List = List
Loading = Loading
Loading.Lower = loading
Location = Location
LocationSettings = Location settings
Lots = Lots

Manual = Manual
Master = Master
MerchantTrack = MerchantTrack
Merge = Merge
mergeSelectedRecords = Are you sure you want to merge these {{objectType}}?
MiddleName = Middle name
MobilePhone = Mobile phone
Modify = Modify
more = more
Money = Money
Months = Months
MultiLineText = Multiline text

Name = Name
Next = Next
No = No
NoCommentHistory = No comment history
NoAddressEntered = No address entered
NoSignature = No signature
Notes = Notes
None = None
Now = Now
Number = Number

of = of
Off = Off
OK = OK
On = On
Open = Open
or = or
Other = Other
OtherTransactions = Other transactions
Output = Output
output = output
Outputs = Outputs

Pdf = PDF
per = per
pendingApproval = pending approval
Phone = Phone
predefinedMessages = Predefined messages
Print = Print
Production = Production
PurchaseCost = Purchase
Purchasing = Purchasing
Produce = Produce
ProfitLoss = "Profit/loss"

Quantity = Quantity
QuantitiesAreInBaseUOM = Quantities are in the base unit of measure
QuantityAdjustment = Quantity adjustment
QuickDateSelector = Quick date selector 
QuickSearchPlaceholder = Quick search ...

Random = Random
Ratio = Ratio
RecentTransactions = Recent transactions
RefreshExchangeRate = Refresh exchange rate
Refund = Refund
RefundSelectedRecords = Are you sure you want to refund these payments?
Remove = Remove
Reports = Reports
ReportSchedule = Report schedule
RestoreStages = Restore stages
RestoreDefaultTemplates = Restore default templates

Sales = Sales
SalesPrice = Sales price
Sample = Sample
Save = Save
Saved = Saved
SaveReport = Save report
UnableToSave = Item costs are still being calculated. Please wait a moment and try again.
Search = Search
SearchTips = Search tips
SearchResults = Search results 
SeeImage = See image
Selected = Selected
selectOptionNone = (none)
Send = Send
Sequential = Sequential
SerialInventory = Serial Inventory
Serials = Serials
Settings = Settings
Shipping = Shipping
ShippingAmount = Shipping Amt
showMore = show more
ShowOnForms = Show on forms
SmartSearch = Smart search
SomethingWentWrong = Something went wrong. Please check your data and resubmit, or contact support by email (support@sosinventory.com) or phone (817-422-5909).
SortTable = Sort table
SosInventory = SOS Inventory
Stages = Stages
State/Province = State/Province
Status = Status
Subtotal = Subtotal
Suffix = Suffix
Submit = Submit
Summary = Summary
Sync = Sync

tagged = tagged
Tax = Tax
TaxPercent = 'Tax %'
Template = Template
TemplateLibrary = Template library
Terms = Terms
Text = Text
Title = Title
to = to
ToDate = To date
Total = Total
Totals = Totals
Type = Type
TypeYourQuery = Type your query

UOM = UOM
Update = Update
Unarchive = Unarchive
Unfavorite = Unfavorite
Unit = Unit
UnitsOfMeasure = Units of measure
UpdateInputs = Update inputs
UseAsTemplate = Use as template
Using = Using
unassigned = unassigned

Variants = Variants
Vendor = Vendor
Volume = Volume

Website = Website
Weeks = Weeks
Weight = Weight
What = What
When = When
WhichOne = Which one
Width = Width
Who = Who

Years = Years
Yes = Yes

OnSO = On SO
OnWO = On WO
OnRMA = On RMA
OnPO = On PO
OnSR = On SR
OnRental = On rental
OnHand = On hand

QuickDateSelector = Quick date selector

[objectType]
account.Lower = account
account.Sentence = Account
account.SentencePlural = Accounts

adjustment.Lower = adjustment
adjustment.LowerPlural = adjustments
adjustment.New = New adjustment
adjustment.Sentence = Adjustment
adjustment.SentencePlural = Adjustments

alert.Lower = alert
alert.LowerPlural = alerts
alert.New = New alert
alert.Sentence = Alert
alert.SentencePlural = Alerts

aoprule.Lower = AOP rule
aoprule.LowerPlural = AOP rules
aoprule.New = New AOP rule
aoprule.Sentence = AOP rule
aoprule.SentencePlural = AOP rules

apiconnection.SentencePlural = API connections
apiconnection.Sentence = API connection

attachment.SentencePlural = Attachments

auditevent.SentencePlural = Activity log
auditevent.Sentence = Activity log
auditevent.LowerPlural = events 

bins.Lower = bin
bins.LowerPlural = bins
bins.New = New bin
bins.Sentence = Bin
bins.SentencePlural = Bins

bill.Lower = bill
bill.Sentence = Bill
bill.SentencePlural = Bills

bom.SentencePlural = BOMs
bom.Sentence = BOM

billpayment.Sentence = Bill payment

build.in.SentencePlural = Build inputs
build.Lower = build
build.LowerPlural = builds
build.New = New build
build.out.SentencePlural = Build outputs
build.Sentence = Build
build.SentencePlural = Builds

cash.Sentence = Cash

cashpurchase.Sentence = Cash purchase

cart.Lower = cart
cart.LowerPlural = carts
cart.New = New cart
cart.Sentence = Cart
cart.SentencePlural = Carts

channel.Lower = channel
channel.LowerPlural = channels
channel.New = New channel
channel.Sentence = Channel
channel.SentencePlural = Channels

check.Sentence = Check

class.Lower = class
class.LowerPlural = classes
class.New = New class
class.Sentence = Class
class.SentencePlural = Classes

creditcardcharge.Sentence = Credit card charge

creditcardcredit.Sentence = Credit card credit

creditmemo.Lower = credit memo
creditmemo.Sentence = Credit memo
creditmemo.SentencePlural = Credit memos

customfield.Lower = custom field
customfield.LowerPlural = custom fields
customfield.New = New custom field
customfield.Sentence = Custom field
customfield.SentencePlural = Custom fields

customer.Lower = customer
customer.LowerPlural = customers
customer.Sentence = Customer
customer.SentencePlural = Customers

customermessage.Lower = customer message
customermessage.LowerPlural = customer messages
customermessage.New = New customer message
customermessage.Sentence = Customer message
customermessage.SentencePlural = Customer messages

customertype.Lower = customer type
customertype.LowerPlural = customer types
customertype.New = New customer type
customertype.Sentence = Customer type
customertype.SentencePlural = Customer types

deleteditem.LowerPlural = deleted items
deleteditem.Lower = deleted item
deleteditem.Sentence = Deleted item
deleteditem.SentencePlural = Deleted items

department.Lower = department
department.LowerPlural = departments
department.New = New department
department.Sentence = Department
department.SentencePlural = Departments

document.Lower = document or file
document.LowerPlural = documents and files
document.New = New document or file
document.Sentence = Document or file
document.SentencePlural = Documents and files

employee.SentencePlural = Employees
employee.Sentence = Employee

estimate.Lower = estimate
estimate.LowerPlural = estimates
estimate.New = New estimate
estimate.Sentence = Estimate
estimate.SentencePlural = Estimates

fileanddocument.Lower = file and document
fileanddocument.LowerPlural = files and documents
fileanddocument.New = New file and document
fileanddocument.Sentence = File and document
fileanddocument.SentencePlural = Files and documents

formtemplate.Lower = form template
formtemplate.LowerPlural = form templates
formtemplate.New = New form templates
formtemplate.Sentence = Form template
formtemplate.SentencePlural = Form templates

templatelibrary.Lower = library template
templatelibrary.LowerPlural = template library
templatelibrary.New = New library template
templatelibrary.Sentence = Library template
templatelibrary.SentencePlural = Template Library

timetracking.Sentence = Time tracking

fspayment.Lower = SOS Pay
fspayment.LowerPlural = SOS Pay
fspayment.Sentence = SOS Pay
fspayment.SentencePlural = SOS Pay


ftpconnection.New = New FTP connection
ftpconnection.Sentence = FTP connection
ftpconnection.SentencePlural = FTP connections

invoice.Lower = invoice
invoice.LowerPlural = invoices
invoice.New = New invoice
invoice.Sentence = Invoice
invoice.SentencePlural = Invoices

item.Lower = item
item.LowerPlural = items
item.Sentence = Item
item.SentencePlural = Items

itemreceipt.Lower = item receipt
itemreceipt.LowerPlural = item receipts
itemreceipt.New = New item receipt
itemreceipt.Sentence = Item receipt
itemreceipt.SentencePlural = Item receipts

job.Lower = job
job.LowerPlural = jobs
job.New = New job
job.Sentence = Job
job.SentencePlural = Jobs

journalentry.Lower = journal entry
journalentry.Sentence = Journal entry
journalentry.SentencePlural = Journal entries

location.Lower = location
location.LowerPlural = locations
location.New = New location
location.Sentence = Location
location.SentencePlural = Locations

lot.Lower = lot
lot.LowerPlural = lots
lot.New = New lot
lot.Sentence = Lot
lot.SentencePlural = Lots

notification.Lower = notification
notification.LowerPlural = notifications
notification.New = New notification
notification.Sentence = Notification
notification.SentencePlural = Notifications

orderstage.Lower = order stage
orderstage.LowerPlural = order stages
orderstage.New = New order stage
orderstage.Sentence = Order stage
orderstage.SentencePlural = Order stages

payment.Lower = payment
payment.LowerPlural = payments
payment.New = New payment
payment.Sentence = Payment
payment.SentencePlural = Payments

paymentmethod.Lower = payment method
paymentmethod.LowerPlural = payment methods
paymentmethod.New = New payment method
paymentmethod.Sentence = Payment method
paymentmethod.SentencePlural = Payment methods

pickticket.Lower = pick ticket
pickticket.LowerPlural = pick tickets
pickticket.New = New pick ticket
pickticket.Sentence = Pick ticket
pickticket.SentencePlural = Pick tickets

process.in.SentencePlural = Process inputs
process.Lower = process
process.LowerPlural = processes
process.New = New process
process.out.SentencePlural = Process outputs
process.Sentence = Process
process.SentencePlural = Processes

processtemplate.Lower = process template
processtemplate.LowerPlural = process templates
processtemplate.New = New process template
processtemplate.Sentence = Process template
processtemplate.SentencePlural = Process templates

pricetier.Lower = price tier
pricetier.LowerPlural = price tiers
pricetier.New = New price tier
pricetier.Sentence = Price tier
pricetier.SentencePlural = Price tiers

priority.Lower = priority
priority.LowerPlural = priorities
priority.New = New priority
priority.Sentence = Priority
priority.SentencePlural = Priorities

purchase.Lower = purchase
purchase.Sentence = Purchase
purchase.SentencePlural = Purchases

purchaseorder.Lower = purchase order
purchaseorder.LowerPlural = purchase orders
purchaseorder.New = New purchase order
purchaseorder.Sentence = Purchase order
purchaseorder.SentencePlural = Purchase orders

reorder.Lower = reorder
reorder.LowerPlural = reorder reminders
reorder.Sentence = Reorder
reorder.SentencePlural = Reorder list

reorder.Lower = reorder
reorder.LowerPlural = reorder reminders
reorder.New = New reorder item
reorder.Sentence = Reorder
reorder.SentencePlural = Reorder list

rental.Lower = rental
rental.LowerPlural = rentals
rental.New = New rental
rental.Sentence = Rental
rental.SentencePlural = Rentals

rentalreturn.Lower = rental return
rentalreturn.LowerPlural = rental returns
rentalreturn.New = New rental return
rentalreturn.Sentence = Rental return
rentalreturn.SentencePlural = Rental returns

return.Lower = return
return.LowerPlural = returns
return.New = New return
return.Sentence = Return
return.SentencePlural = Returns

returntovendor.Lower = return to vendor
returntovendor.LowerPlural = returns to vendors
returntovendor.New = New return to vendor
returntovendor.Sentence = Return to vendor
returntovendor.SentencePlural = Returns to vendors

rma.Lower = RMA
rma.LowerPlural = RMAs
rma.New = New RMA
rma.Sentence = RMA
rma.SentencePlural = RMAs

salesorder.Lower = sales order
salesorder.LowerPlural = sales orders
salesorder.New = New sales order
salesorder.Sentence = Sales order
salesorder.SentencePlural = Sales orders

salesreceipt.Lower = sales receipt
salesreceipt.LowerPlural = sales receipts
salesreceipt.New = New sales receipt
salesreceipt.Sentence = Sales receipt
salesreceipt.SentencePlural = Sales receipts

salesterm.Sentence = Sales term

salesrep.Lower = sales rep
salesrep.LowerPlural = sales reps
salesrep.New = New sales rep
salesrep.Sentence = Sales rep
salesrep.SentencePlural = Sales reps

serial.Lower = serial item
serial.LowerPlural = serial items
serial.New = New serial item
serial.Sentence = Serial item
serial.SentencePlural = Serial items

serialinventory.SentencePlural = Serial inventory

shipment.Lower = shipment
shipment.LowerPlural = shipments
shipment.New = New shipment
shipment.Sentence = Shipment
shipment.SentencePlural = Shipments

shipmethod.Lower = Shipping method
shipmethod.LowerPlural = Shipping methods
shipmethod.New = New shipping method
shipmethod.Sentence = Shipping method
shipmethod.SentencePlural = Shipping methods

syncerror.Lower = sync error
syncerror.LowerPlural = sync errors
syncerror.New = New sync error
syncerror.Sentence = Sync error
syncerror.SentencePlural = Sync errors

syncitem.Sentence = Sync item
syncitem.Lower = sync item
syncitem.LowerPlural = sync items
syncitem.SentencePlural = Sync queue

tag.Lower = tag
tag.LowerPlural = tags
tag.New = New tag
tag.Sentence = Tag
tag.SentencePlural = Tags

task.Lower = task
task.LowerPlural = tasks
task.New = New task
task.Sentence = Task
task.SentencePlural = Tasks

taxcode.SentencePlural = Tax codes

templatelibrary.Lower = library template
templatelibrary.LowerPlural = template library
templatelibrary.New = New library template
templatelibrary.Sentence = Library template
templatelibrary.SentencePlural = Template library

terms.Lower = term
terms.LowerPlural = terms
terms.New = New term
terms.Sentence = Term
terms.SentencePlural = Terms

transfer.Lower = transfer
transfer.LowerPlural = transfers
transfer.New = New transfer
transfer.Sentence = Transfer
transfer.SentencePlural = Transfers

upsaccount.Lower = UPS account

user.Lower = user
user.LowerPlural = users
user.New = New user
user.Sentence = User
user.SentencePlural = Users

vendor.Lower = vendor
vendor.LowerPlural = vendors
vendor.Sentence = Vendor
vendor.SentencePlural = Vendors

vendorcredit.Sentence = Vendor credit
vendorcredit.SentencePlural = Vendor credits

vendoritem.Lower = vendor item catalog
vendoritem.LowerPlural = vendor items catalog
vendoritem.New = New vendor item
vendoritem.Sentence = Vendor-item catalog
vendoritem.SentencePlural = Vendor-item catalog

workorder.Lower = work order
workorder.LowerPlural = work orders
workorder.New = New work order
workorder.Sentence = Work order
workorder.SentencePlural = Work orders

uom.Lower = unit of measure
uom.LowerPlural = Units of measure
uom.New = New unit of measure
uom.Sentence = Unit of measure
uom.SentencePlural = Units of measure

upslabel.Sentence = UPS label

upsshipment.Lower = UPS shipment
upsshipment.LowerPlural = UPS shipments
upsshipment.New = New UPS shipment
upsshipment.Sentence = UPS shipment
upsshipment.SentencePlural = UPS shipments

vendormessage.Lower = vendor message
vendormessage.LowerPlural = vendor messages
vendormessage.Sentence = Vendor message
vendormessage.New = New vendor message
vendormessage.SentencePlural = Vendor messages

warranty.Lower = warranty
warranty.LowerPlural = warranties
warranty.New = New warranty
warranty.Sentence = Warranty
warranty.SentencePlural = Warranties

workcenter.Lower = work center
workcenter.LowerPlural = work centers
workcenter.New = New work center
workcenter.Sentence = Work center
workcenter.SentencePlural = Work centers

worker.Lower = worker
worker.LowerPlural = workers
worker.New = New worker
worker.Sentence = Worker
worker.SentencePlural = Workers

[restricted]
Title = Your account does not have the correct access
Info = You tried to reach a page that your user account does not have access to. Please contact your account administrator 

EditTitle = Your account does not have the correct edit access
EditInfo = You tried to reach an area that your account does not have access to. Please contact your account administrator 

[listPage]

Widgets.export = Export


NoResultsFound = No results found

[filter]

Added = Added
Edited = Edited
Deleted = Deleted
Emailed = Emailed
Synced = Synced

Action = Action
All = All
all = all
Any = Any
archive.yes = Show archived
archive.no = Show not archived
archive.both = Show all
AssignedTo = Assigned to

BinTrackedLocation = Bin tracked location
BinTrackedLocations = Bin tracked locations

CameFromOrWentTo = Trace where lot...
Category = Category
Categories = Categories
Class = Class
Customer = Customer
Department = Department

expiredRecalled.all = All
expiredRecalled.notExpiredNotRecalled = Not expired, not recalled
expiredRecalled.expired = Expired
expiredRecalled.recalled = Recalled

FromLocation = From location
Heading = Filters
Item = Item
Location = Location
Locations = Locations
label = Filter
Type = Type
ResultsPerPage = Results per page
SyncObject = Object

Lot = Lot
Status = Status
User = User

status.Accepted = Show accepted only
status.Active = Show active only
status.AdjustedOut = Adjusted out
status.Closed = Show closed only
status.Completed = Show completed only
status.Inactive = Show inactive only
status.InStock = In-stock
status.NotVoided = Show not voided only
status.Open = Show open only
status.Pending = Show pending only
status.Rejected = Show rejected only
status.NotVoided = Show not voided only
status.Voided = Show voided only
status.InStock = In stock
status.Used = Used
status.Shipped = Shipped
status.Voided = Show voided only
status.Converted = Show converted only

Tags = Tags
ToLocation = To location
TotalOnly = Total only
Type = Type
Unassigned = Unassigned
Variants = Variants
variant.show = Show variants
Vendor = Vendor

heading.asOf = as of
heading.archive.Both = archived and unarchived
heading.archive.No = unarchived
heading.archive.no = unarchived
heading.archive.Yes = archived
heading.from = from
heading.intro.listPage = showing
heading.intro.report = selecting
heading.to = to

heading.cameFromOrWentTo.CameFrom = where lot came from
heading.cameFromOrWentTo.WentTo = where lot went to

heading.status.Accepted = accepted
heading.status.Active = active
heading.status.Inactive = inactive
heading.status.AdjustedOut = adjusted out
heading.status.all = all
heading.status.Both = open and closed
heading.status.Closed = closed
heading.status.completed = completed
heading.status.Expired = expired
heading.status.InStock = in stock
heading.status.No = open
heading.status.open = open
heading.status.NotExpiredNotRecalled = not expired and not recalled
heading.status.notvoided = unvoided
heading.status.Pending = pending
heading.status.Recalled = recalled
heading.status.Rejected = rejected
heading.status.Shipped = shipped
heading.status.Used = used
heading.status.voided = voided
heading.status.Yes = closed

heading.itemType.Account = account
heading.itemType.Assembly = assembly
heading.itemType.Bill = bill
heading.itemType.Category = category
heading.itemType.Class = class
heading.itemType.CreditMemo = credit memo
heading.itemType.Customer = customer
heading.itemType.CustomerType = customer type
heading.itemType.Department = department
heading.itemType.Estimate = estimate
heading.itemType.Expense = expense
heading.itemType.InventoryItem = regular
heading.itemType.Invoice = invoice
heading.itemType.Item = item
heading.itemType.ItemGroup = item group
heading.itemType.JournalEntry = journal entry
heading.itemType.Labor = labor
heading.itemType.Non-inventoryItem = non-inventory
heading.itemType.Other = other
heading.itemType.Overhead = overhead
heading.itemType.PaymentMethod = payment method
heading.itemType.Purchase = purchase
heading.itemType.PurchaseOrder = purchase order
heading.itemType.SalesReceipt = sales receipt
heading.itemType.SalesTerm = sales term
heading.itemType.Service = service
heading.itemType.Vendor = vendor
heading.itemType.VendorCredit = vendor credit

heading.fromExpiration = from expiration
heading.toExpiration = to expiration
heading.variants.HideVariants = "(excluding variants)"

[columnSelect]

dragDropInstructions = Drag and drop column names to add or remove from the display, or to reorder the columns names currently displayed.
current = Current
available = Available
Heading = Columns

[iconAltText]
search = Search SOS Inventory
create = Add new transaction
toolsAndSettings = Tools and settings
sync = Sync with QuickBooks
print = Print
messages = Notifications
help = Help
user = User

[topNav]
companyMenu.accountInformation = Account information
companyMenu.users = Users

syncMenu.syncNow = Sync Now
syncMenu.previewSync = Preview Sync
syncMenu.syncErrors = Sync Errors
syncMenu.accounts = Accounts
syncMenu.bills = Bills
syncMenu.classes = Classes
syncMenu.credits = Credit Memos
syncMenu.departments = Departments
syncMenu.employees = Employees
syncMenu.journals = Journal Entries
syncMenu.purchases = Purchases
syncMenu.taxCodes = Tax Codes

settingsMenu.settings = Configuration
settingsMenu.financialList = Financial lists
settingsMenu.dataTools = Data tools
settingsMenu.import = Import data
settingsMenu.export = Export data
settingsMenu.dataUtilities = Data utilities
settingsMenu.support = Support console
settingsMenu.activityLog = Activity log

helpMenu.userGuide = User guide
helpMenu.helpCenter = Help center
helpMenu.faq = Frequently asked questions
helpMenu.videos = Video tutorials
helpMenu.howTo = How-to guides
helpMenu.customerTraining = Customer training
helpMenu.new = What's new
helpMenu.features = Feature requests
helpMenu.status = System status
helpMenu.mobile = Mobile app
helpMenu.contact = Contact us
helpMenu.about = About

userMenu.userSettings = User settings
userMenu.changePassword = Change password
userMenu.tasks = Tasks
userMenu.signOut = Sign out

notificationMenu.NoNotifications = You have no notifications
notificationMenu.SeeAll = See all notifications

[leftNav]
Rentals = Rentals
Reports = Reports
QuickLinks = Quick links
AddThisPage = Add This Page
DataTools = Data tools
ExportData = Export data

[login]
Subtitle = © SOS Inventory Software, LLC
EmailField = Email
PasswordField = Password
RememberMe = Remember Me:
SignIn = Sign in
QBOAltText = Sign in with QuickBooks Online
NeedAccount = I need an account
ForgotPassword = I forgot my password
Support = Need help logging in?
Agreement = By signing in, you agree to the SOS Inventory 
MasterServiceAgreement = Master Service Agreement
Privacy = PrivacyPolicy
TimeoutMessage = You will be logged out due to inactivity in one minute.
Logout = Logout
Stay = Stay
LoggingIntoSOS = We are currently logging you into SOS Inventory...

[chooseCompany]
Link = Change company
SubscribeButton = Subscribe
Header = Choose a company
AutomaticCheck = Automatically go to this company when I log in
HelpText = If you choose this option, you'll still be able to switch companies at any time.

[trial]
Title = Sign up for a free SOS Inventory trial
SubTitle = 14 day free trial. No credit card required. Upgrade, downgrade, or cancel at anytime.
SelectPlan = Select a plan
ClickButtonGetStarted.1 = Click the button for a plan to get started. You can always change it later. Or see our
ClickButtonGetStarted.2 = detailed feature comparison. 
INeedAnAccount = I need an account
StartTrial = Start trial
CreateCompanyLinkedToUserAccount = This will create a new company account linked to your existing user account.
AlreadyHaveAnExistingAccount = If you already have an SOS user account, enter your existing password to link this new company trial account to it. If you're new, enter a password you'd like to use for your new user account.
LoggedInSignupSuccess = New company account created.
LoggedOutSignupSuccess = Your company account was created. You can now log in.

Signup.title.1 = The
Signup.title.2 = plan
Signup.title.3 = Good choice. You're almost there!

ContactInformation = Contact information
Signup.Subtitle = We need a little info to get you started. We won't share any information without your permission.

companion.1 = Sales orders.
companion.2 = Assemblies.
companion.3 = Best-in-class QuickBooks integration.
plus.1 = Unlimited locations.
plus.2 = Serial/lot tracking.
plus.3 = Barcoding.
pro.1 = Job costing.
pro.2 = Advanced manufacturing.
pro.3 = Customer portal.

subTitle.companion = (basic inventory)
subTitle.plus = (most popular)
subTitle.pro = (advanced automation)

footer.support.1 = Email
footer.support.2 = or call

MasterServiceAgreement = Master Service Agreement
PrivacyPolicy = Privacy policy
TermsOfServiceAgreement = By clicking "Start trial" below I agree to SOS Inventory's
TermsOfService = Terms of Service

[button]
Add = ADD
AddDocument = ADD DOCUMENT
Apply = APPLY
Cancel = CANCEL
Clear = CLEAR
Close = CLOSE
Delete = DELETE
Done = DONE
Generate = GENERATE
Merge = MERGE
Reset = RESET
Send = SEND
Submit = SUBMIT
UploadCSV = UPLOAD CSV
Test = TEST
Confirm = CONFIRM
OK = OK

[saveAndSend]
Title = Send form via email
To = To
ToHelper = Separate multiple addresses with commas
ToError = Must contain one or more valid email addresses, separated by commas
Subject = Subject
Message = Message
CopyMe = Send copy to me
Template = Template
TemplateError = Must select a template

[search]
Tips = Search tips
Results = Search Results
For = Search for customers, items, vendors, or transactions. 
TipsAndKeywords = Search tips and keywords
Description = Smart search allows you to perform a global search in SOS Inventory for a specific list item or transaction. Enter any text to return all matches for that text, or use a keyword to specify the type of transaction to return.
AvailableKeywordsBelow = The available keywords are listed below:
TipExample = As an example, you could enter "5177" (without quotes) to find anything with 5177 in the name or ID. But if you search for "po 5177" (without quotes) it would look for purchase order ID 5177 only. In this case it would take you directly to the appropriate list page.
QuotesTip = If you are not using an SOS keyword, enclose a phrase in quotes to obtain precise search results. For example, "Flight Jacket" finds anything with that phrase as part of the name or description (depending on the inventory settings you have configured for searches). Without the quotes, SOS looks for every possible match for that phrase.

[serials]
Enter = Enter serial numbers
Upload = Upload serial numbers
EnterUpload = Enter/upload serial numbers
SelectUpload = Select/upload serial numbers
UploadCSV = Upload CSV file
CSVUploadInfo = One or more of the serials you uploaded is not available in inventory at this location, or is already selected.
Available = Available
ClickToRemove = click to remove
MustSelectLocation = Select a location from which to select serialized inventory.
UploadSerialNumbers = Upload serial numbers
ChooseSerialFileAndImport = Choose serial number file and import

[lots]
DeleteRecordsLotHasOnhand = The selected lot has inventory on hand and cannot be deleted.
DeleteRecordsLotUsedOnTransactions = The selected lot has been used on transactions and cannot be deleted.
LineItemLotNotFound = Lot {{lotName}} not found in lot data for line {{lineNumber}}, item {{itemName}}

[history]
customerName = To/from customer
fromLocation = From location
LineItems = Line items
Location = Location
refNumber = "Txn #"
toLocation = To location
Total = Total
txnDate = Date
txnType = Txn type
type = Transaction type
quantity = Quantity
value = Value
vendorName = From/to vendor
NET = NET

[locationSettings]
location = Location
reorderPoint = Reorder point
maxStock = Max stock
defaultBin = Default bin

[payment]
None = None
Bill = Bill
CashPurchase = Cash
Check = Check
CreditCardCharge = Credit Card
endingIn = ending in
EnterAchInfo = Enter ACH info
EnterCardInfo = Enter card info
PaymentMethodDisabledOnEdit = Updating the payment method is disabled on payment transactions where an SOS payment has already been made
SosPayOptionsDisabled = SOS pay options are only available on new payment transactions
LearnHowToProcessPayments = Learn how to process payments on sales receipts.
EnterYourPaymentInformation = Enter your payment information

year = year
month = month

terms.title = Subscription terms
terms.2 = You are subscribing to the {{plan}} plan at {{amount}} per {{term}}.
terms.3 = Your 14-day free trial ends on {{trialEnd}}. Your card will be charged {{amount}} on {{chargeDate}} (the "Effective Date") unless you cancel before then.
terms.4 = Price may change if you update your plan, billing frequency, or number of users.
terms.5 = Your subscription auto-renews every {{term}} until you cancel.
terms.refund.label = Refunds:
terms.refund.body = If you request a refund within 30 days of your initial payment, we will refund your initial payment. Thereafter, no refunds are permitted.
terms.term.label = Term:
terms.term.monthly = The term of the Agreement shall begin on the Effective Date and continue for one month thereafter (the "Initial Term"). After the Initial Term, the term of the Agreement shall automatically renew for additional, one (1) month terms unless either party provides written notice of termination to the other party no less than 15 days to the end of the current term by returning to the Account Information page and clicking "Cancel Subscription". The Initial Term together with any renewed terms shall collectively be referred to as the "Term."
terms.term.annual = The term of the Agreement shall begin on the Effective Date and continue for twelve (12) months thereafter (the "Initial Term"). After the Initial Term, the term of the Agreement shall automatically renew for additional, successive twelve (12) month terms unless either party provides written notice of termination to the other party no less than sixty (60) days prior to the end of the current term by returning to the Account Information page and clicking "Cancel Subscription". The Initial Term together with any renewed terms shall collectively be referred to as the "Term."
terms.agreeCheckbox.1 = By checking this box I agree to the above Subscription terms and the
AddPayment = Add payment

By clicking Save, you authorize SOS Inventory to charge your card in accordance with these terms.

[address]
Shipping = Shipping address
BillTo = Bill to
Billing = Billing address
Vendor = Vendor address
Customer = Customer
CustomerAddress = Customer address
ShipTo = Ship to

[vendor]
LineItemError.Name = Name field is required.
Error.Email = You must enter a valid email.
Error.Website = Invalid URL.

Address = Vendor address

[transactionHistory]
txnDate = Date/time
type = Transaction type
refNumber = "Transaction #"
lines = Line items
location = Location
total = Total
customerPO = Customer PO

[file]
FileTypeNotSupported = File type of {{fileType}} is not currently supported.
ImageScaledToFit = Image (scaled to fit)
LogoScaledToFit = Logo (scaled to fit)
Image = Image

[item]
placeholderSalesDescription = Description on sales forms
placeholderPurchasingDescription = Description on purchasing forms

typeOptionInventoryItem = Inventory item
typeOptionNonInventory = Non-inventory
typeOptionCategory = Category
typeOptionExpense = Expense
typeOptionItemGroup = Kit (item group)
typeOptionAssembly = Assembly
typeOptionService = Service
typeOptionLabor = Labor
typeOptionOverhead = Overhead
typeOptionOther = Other

headingSync = Sync with
headingStartingInventory = Starting inventory
headingUsedOn = Used on
headingSalesTransactionFields = For sales transactions:
headingPurchasingTransactionFields = For purchasing transactions:
headingAccounts = Accounts

switchLabelFixedPricing = Fixed pricing
switchLabelMarkupPricing = Markup pricing

imageChange = Change image
imageAdd = Add image
imageRemove = Remove image

Error.needInitialBin = This location requires a bin to be chosen.
Error.Name = Name field is required.
Error.AssetAccount = You must specify an asset account for inventory and assembly items to sync with QuickBooks.
Error.IncomeOrExpenseAccount = You must specify either an income account or an expense account to sync with QuickBooks.
Error.IncomeOrCogsAccount = You must specify either an income account or a COGS account to sync with QuickBooks.

fieldError.incomeAccount = If you do not have an income account selected, QuickBooks will delete the sales description and sales price when this item synchronizes.
fieldError.cogsAccount = If you do not have a COGS account selected, QuickBooks will delete the purchase description and purchase price when this item synchronizes.
fieldError.expenseAccount = If you do not have an expense account selected, QuickBooks will delete the purchase description and purchase price when this item synchronizes.
withVariants = with variants
variant = variant

[bin]
NoBins = No bins with this item
DeleteDisabled = This bin cannot be deleted because it contains items.
batchDeleteDisabled = Cannot delete bins with contents. The following bins cannot be deleted because they still contain contents: {{contents}}.

[worker]
NoWorkers = No workers are associated with this account

[reorder]
Error.Item = You must choose an inventory item.

[serial]
Error.Item = You must specify the item type.
Error.Number = You must specify a serial number.

[itemReceipt]
fieldReceived = Received

labelNumber = "Item receipt reference #"

OtherCostsHeader = Other costs

Error.Date = You must enter a valid receipt date and time.
Error.Vendor = You must select a vendor.
Error.MissingBins = You must select a bin on every line that requires one.

LineItemError.MissingBin = You must select a bin on line {{lineNumber}}.
LineItemError.QuantityOverflow = Quantity on line {{lineNumber}} must have 8 or fewer digits left of the decimal point.
LineItemError.UnitpriceOverflow = Unit price on line {{lineNumber}} must have 8 or fewer digits left of the decimal point.
LineItemError.AmountOverflow = Amount on line {{lineNumber}} must have 8 or fewer digits left of the decimal point.

[returnToVendor]

labelNumber = "Return to vendor reference #"
labelAccount = Account

[purchaseOrder]
labelAbbreviated = PO
labelAbbreviatedNumber = "PO #"
labelExpectedDate = Expected date
labelExpectedShip = Expected ship
ShippingAddress = Shipping address
labelNumber = "Purchase order reference #"
blanketPO = Blanket PO
ExpandShippingAddress = Update your shipping address
ExpandVendorAddress = Update your vendor address
DoneEditing = Done editing
Error.Customer = You must select a customer for drop ship purchase orders.
SuggestedQuantity = Suggested quantity
EmailDisabled = You cannot email a purchase order that has not been approved.

[salesOrder]
labelAbbreviated = SO
labelNumber = "Sales order reference #"

[shipment]
labelNumber = "Shipment reference #"

[pickTicket]
labelNumber = "Pick ticket reference #"

[transfer]
labelNumber = "Transfer reference #"

[adjustment]
labelNumber = "Adjustment reference #"

[salesReceipt]
labelNumber = "Sales receipt reference #"

[workOrder]
labelAbbreviatedNumber = "WO #"
labelNumber = "Work order reference #"

[process]
labelNumber = "Process reference #"

[build]
labelNumber = "Build reference #"

[rental]
labelAbbreviated = Rental
labelNumber = "Rental reference #"

[rentalReturn]
labelNumber = "Rental return reference #"

[rma]
labelAbbreviated = RMA
labelNumber = "RMA reference #"

[return]
labelNumber = "Return reference #"

[payment]
labelNumber = "Payment reference #"

[lineItemErrors]
InvalidSerialQty = Invalid qty for serial entry

[hoverHelp]
Importing = Select the type of data to import.
ImportAsOf = The adjustment for this import will be for the end of the date selected. If you use today's date, it will not reflect in inventory until that time.
alert.EnterAValueToCompare = Enter a value to compare against
alert.Max30Min30 = Enter a number. The maximum is 30 and the minimum is -30.
alert.RepeatAlert = After the initial alert, how often do you want to be notified again (if the condition still exists)?
alert.AlertInterval = How often do you want to check for the condition?
alert.ActiveAlert = Check to make this alert active.
OwnPackaging = Dimensions are required only when using your own packaging

alwaysShippable = Always show on shipments.
AssetAccount = Account to record inventory on hand for this work center.
AutomatedSalesTax = Your QuickBooks account is configured for automated sales tax. When you synchronize, QuickBooks will calculate the tax automatically.
AutomatedSalesTaxSalesOrder = Your QuickBooks account is configured for automated sales tax. When you invoice this sale, QuickBooks will calculate the tax automatically.
autoSerialLots = If checked, serial and lot numbers will be generated automatically, according to your settings.
barcode = Scan or type the barcode that the system will use to recognize this item.
BinTracking = Enable this option if this location is organized into bins. If not enabled at the time the location is created, this setting cannot be changed later. A new location must be created with the desired bin tracking setting, and then inventory must be transferred into the proper bins at the new location. If you need assistance, please email support@sosinventory.com. 
BinTracking.WithSupportNumber = Enable this option if this location is organized into bins. If not enabled at the time the location is created, this setting cannot be changed later. A new location must be created with the desired bin tracking setting, and then inventory must be transferred into the proper bins at the new location. If you need assistance, please email support@sosinventory.com or call 817-422-5909.
BaseUnit = Select the base unit of measure for this item. This would typically be the smallest unit that you use for this item.
blanketPO = Check the box above to make this a blanket PO (open-ended). The quantity column is ignored on a blanket PO.

comment = This comment will not be shown when this form is printed or emailed.
commissionExempt = Check this box if you don't pay commission for this item.
commissionRate = Percentage commission for sales reps on this item.
commissionAmount = Per unit commission for sales reps for this item.
CreateBill = This will create a bill from the vendor associated with the shipping method.
CreateCreditMemo = Check this box to send a credit memo to QuickBooks on the next sync. This will remove any existing credit memos linked to this return.
createVendorCredit = Check this box to send a vendor credit to QuickBooks on the next sync. This will remove any existing credits linked to this return.
CustomerHoverHelp = Customer who has this serial item, if applicable.
CustomerText = This is the text that will show to the customer on the customer portal.
CustomerTypeName = Enter the name for this customer type. Note that QuickBooks does not allow customer types created in third-party apps to be created in QuickBooks. So you might want to create your customer types in QuickBooks and have them synchronize to SOS Inventory.
CustomFieldList = Enter the possible values for this list, seperated by commas.
CustomListNoOptions = This custom list field has no list values. Add them in the custom field definition.
CustomerOptional = This field is optional. You do not have to specify a customer.
ForceToShipStation = Checking this box will send the transaction to ShipStation the next time ShipStation retrieves data from SOS, even if ShipStation does not request it.
deposit = For your reference only. It will not sync to QuickBooks.

customField.dd/MM/yyyy = Please enter the date in dd/mm/yyyy format, where the day and month can be 1 or 2 digits, and the year must be 4 digits. Use / as the separator between day, month, and year segments. For example, 12/30/2023
customField.M/d/yyyy = Please enter the date in mm/dd/yyyy format, where the day and month can be 1 or 2 digits, and the year must be 4 digits. Use / as the separator between day, month, and year segments. For example, 30/12/2023

EmailTemplate = Select the template that you want to use when emailing this form.
EmailAttachment = Only linked files can be sent as attachments.
itemName = The item name should be whatever you want to use to refer to this item in the system.
leadTime = Depending on your settings, this value might be overridden by automatic calculations.
LocationDefault = Check the box to make this location the default location.
minimumSalesPrice = Transactions attempting to sell the item for less than this price will be rejected.
NonNettable = If this option is selected, items in this location will not count toward the available-for-sale quantity. This can be convenient for work-in-progress or out-of-service units, for example.
NotSearchable = Unchecking the box will make this item not searchable on this transaction type
OrderStageSortOrder = This is the order of the stages. For example, the first stage would have a 1 here. 
payment = Method you used to pay for the items. If you choose "None", no transaction will be sent to QuickBooks.
PriceTier = Apply will update all lines to the selected price tier.
PrioritySortOrder = This is the order of the priorities. For example, priorty 1 would have a 1 here. 
reorderPoint = Depending on your settings, this value might be overridden by automatic calculations.
SalesTaxRatePercent = Default sales tax rate for this location, specified as a percentage. This setting applies only when not using the Sales Tax Center in QuickBooks Online. 
SequenceNumber = Sequence number to order the bins. For example, 1, 2, 3, etc. The minimum value is 0 and the maximum is 9999. The default is 0. Typically this would be the order of the bins in the warehouse.
SeparateEmailByComma = Separate multiple email addresses with a comma.
Share = Check this box to allow other users to view this document.
sku = Scan or type the SKU that the system will use to recognize this item. This field syncs with the SKU field in QuickBooks Online.
StatusMessage = This message shows when the customer views the order status.
UniqueName = Use a unique name so that you can remember what this {{objectType}} means.

PercentCommission = Calculates commission as a percentage of sales on transactions assigned to this sales rep.
CommissionAmount = Calculates commission as a flat rate per sale on transactions assigned to this sales rep. 
preferredVendor = If you need to set up more than one vendor for this item, use the vendor-item catalog.
RestrictCustomers = Check this box to restrict this sales rep to information for their customers only. Enabling this setting also denies the sales rep access to the Reports page.
StorePaymentInformation = Check this box to store this payment information securely for later use. The payment information is not stored by SOS. It is stored in a highly-secure, PCI II compliant data center.
UpdateDefaultCosts = If checked, the costs on this receipt will become the new default costs for those items.
UpdateInputs = This action requires that the output selection is an assembly.
variantNew = Check this box if you will set up variations of this item later (color, size, version, etc).
vendorCreditAccount = Select the account to which this transaction will post. A credit will post to the asset account and a debit will post to the selected account.
willSync = Uncheck this box if you don't want this item to sync with QuickBooks.
User = Select the SOS user account for this sales rep. This is optional, and you can add it at any time.
VariantItemName = Leave this column blank if adding a new variant item. Note: The name of any existing item that is linked will be changed to match the variant name.

Term.DayOfMonthDue = Date of the month by which payment must be received. This setting is used only when a Due days value is not specified. 
Term.DueDays = Number of days from the delivery of goods or services until the payment is due. If a Due days value is specified, only Discount days and Discount percent can also be specified. 
Term.DueNextMonthDays = When a transaction is issued within the specified number of days prior to the Day of month due, the payment will be due the following month. This setting is used only if a Due days value is not specified. 
Term.DiscountDays = Used only when a Due days value is specified. Discount days indicates the number of days for which the discount is applicable, if the payment is made within Due days. If Discount days is used, you must also specify the Discount percent. 
Term.DiscountDayOfMonth = Discount applies if paid before that day of month. This value is used in conjunction with Date discount percent. Discount day of month can be used only if a Due days value is not specified. 
Term.DiscountPercent = Used only when a Due Days value is specified. The percentage of discount to be applied against the sales list price, if paid within the days specified by Discount Days. If Discount percent is used, you must also specify the Discount days. 
Term.DateDiscountPercent = Percentage of discount that is available against a price, if paid before Discount day of month. This value is used in conjunction with Discount day of month. Date discount percent can be used only if a Due days value is not specified.

user.Administrator = Check to make this user an SOS Inventory company administrator, and to have all of the privileges below. Note that you cannot change the master administrator.

valuationMethod.LIFO = If you want to designate LIFO as your valuation method, please email support@sosinventory.com.
valuationMethod.LIFO.WithSupportNumber = If you want to designate LIFO as your valuation method, please contact support at support@sosinventory.com or 817-422-5909.

shipMethod.ShipStationCarrier = Optional, but helpful if integrating with ShipStation. This setting allows SOS to match the carrier on ShipStation notifications.
shipMethod.ShipStationService = Optional, but helpful if integrating with ShipStation. This setting allows SOS to match the service on ShipStation notifications.
shipMethod.CarrierCode = This setting allows SOS to match the carrier on incoming EDI transactions.
shipMethod.Vendor = Vendor associated with this shipping method. This is used when SOS generates bills for shipping costs.

vendorItem.LeadTime = Expected lead time for this item from this vendor.
vendorItem.Price = Price you pay this vendor for this item.
vendorItem.VendorPartNumber = The part number that this vendor uses when referring to the item.

Share = Check this box to allow other users to view this document.

WorkCenter.SortOrder = Sequence number to order the work centers. For example, 1, 2, 3, etc. The minimum value is 0 and the maximum is 999. The default is 0.

ShipStation.enabled = Check this box to enable/disable ShipStation integration.
ShipStation.sendForSku = Shipment lines sent to ShipStation will use this value as the Shopify SKU. (Item ID is a unique identifier for an inventory item, set internally by the SOS application.)
ShipStation.sendForDescription = Shipment lines sent to ShipStation will use this option to populate the description field in Shopify.

cart.connectionType = Type of cart.
cart.name = Use a unique name so you remember this cart connection.
cart.enabled = Check this box to enable integration with this cart.
cart.connectionType = Type of cart.
cart.channel = Orders coming from the cart will be assigned this sales channel.
cart.class = Orders coming from the cart will be assigned this class.
cart.department = Orders coming from the cart will be assigned this department.
cart.location = Incoming transactions from the cart will be assigned to this location.
cart.enabled = Check this box to enable integration with this cart.
cart.name = Use a unique name so you remember this cart connection.
cart.followInstructions = Follow the instructions to find the proper value for this field.
cart.leaveBlankToKeepSecret = Leave blank to keep existing secret.
cart.txnType = Transactions coming from the cart will be imported into SOS as this transaction type.
cart.updateInventory = Check this box if you want SOS to update inventory in this cart. You can also control this behavior at the item level.
cart.useCommonCustomer = By default, SOS will create a customer for each customer coming from the cart. Check this box to link all cart orders to the same common customer.
cart.useSosDescription = By default, SOS will use the item description coming from the cart. Check this box to override it with the SOS description.
cart.useSosOrderNumber = By default, SOS will use the order number coming from the cart. Check this box to override it with the next SOS order number.
cart.shopifyAppType = Starting February 2022, most Shopify app connections are listed as Custom App. The app type can be seen in the Private Apps section of your Shopify config.

vendor.notes = QuickBooks does not support syncing the Vendor notes field, so what you enter here will not show in QuickBooks and vice-versa.

itemReceipt.DateField = Date these items will be brought into inventory and the date of the vendor bill.

[Dates]
30DaysAgo = 30 days ago
365DaysAgo = 365 days ago
60DaysAgo = 60 days ago
90DaysAgo = 90 days ago

AllDates = All dates
Dates = Dates

endOf.LastMonth = End of last month
endOf.LastQuarter = End of last quarter
endOf.LastWeek = End of last week
endOf.LastYear = End of last year
endOf.NextMonth = End of next month
endOf.NextQuarter = End of next quarter
endOf.NextWeek = End of next week
endOf.NextYear = End of next year
endOf.ThisMonth = End of this month
endOf.ThisQuarter = End of this quarter
endOf.ThisWeek = End of this week
endOf.ThisYear = End of this year

startOf.LastMonth = Start of last month
startOf.LastQuarter = Start of last quarter
startOf.LastWeek = Start of last week
startOf.LastYear = Start of last year
startOf.NextMonth = Start of next month
startOf.NextQuarter = Start of next quarter
startOf.NextWeek = Start of next week
startOf.NextYear = Start of next year
startOf.ThisMonth = Start of this month
startOf.ThisQuarter = Start of this quarter
startOf.ThisWeek = Start of this week
startOf.ThisYear = Start of this year

From = From

LastMonth = Last month
LastMonthtoDate = Last month-to-date
LastQuarter = Last quarter
LastQuarterToDate = Last quarter-to-date
LastWeek = Last week
LastWeekToDate = Last week-to-date
LastYear = Last year
LastYearToDate = Last year-to-date

Next4Weeks = Next 4 weeks
NextMonth = Next month
NextQuarter = Next quarter
NextWeek = Next week
NextWeek = End of next week
NextYear = Next year

To = To
Today = Today

ThisMonth = This month
ThisMonthToDate = This month-to-date
ThisQuarter = This quarter
ThisQuarterToDate = This quarter-to-date
ThisWeek = This week
ThisWeekToDate = This week-to-date
ThisYear = This year
ThisYearToDate = This year-to-date

Yesterday = Yesterday

Since30DaysAgo = Since 30 days ago
Since365DaysAgo = Since 365 days ago
Since60DaysAgo = Since 60 days ago
Since90DaysAgo = Since 90 days ago

[alert]
ClearCache = Cache cleared succesfully
CopiedToClipboard = Copied to Clipboard
DirtyPageCloseConfirm = Are you sure? Changes you made may not be saved

ErrorDuplicateSerial = You already have an item of type serial with serial number {{name}}
ErrorGeneral = An error occurred
ErrorGeneratingPos = Error generating purchase orders
ErrorDeletedComment = Error deleting comment
ErrorPreviewingDataImport = Error previewing data Import
ErrorNotAddedToReorderList = Item(s) could not be added to the reorder list
ErrorMerchantTrack = Error retrieving MerchantTrack information
ErrorProduceAll = Error producing all
ErrorSavingBillOfMaterials = Error saving bill of materials
ErrorCreatingNewCustomer = Error creating new customer
ErrorCreatingNewVendor = Error creating new vendor
ErrorSavingPaymentMethod = Error saving payment method
ErrorNotAddedToReorderList = Item(s) could not be added to the reorder list
ErrorGeneral = An error occurred
ErrorDuplicateSerial = You already have an item of type serial with serial number {{name}}
ErrorUpdatePlan = Error updating plan
ErrorCopyTemplateToAccount = Error copying template(s) to your account
ErrorRetrievingPricingFromUps = Error retrieving rate pricing from UPS

ErrorDelete = Error deleting {{type}}
ErrorRevoke = Error revoking API connection
SuccessDelete = Successfully deleted {{type}}
SuccessRevoke = Successfully revoked API connection

UnableToUpdate = Unable to update

RefundPaymentSuccess = Successfully refunded payment
SaveDocumentSuccess = Successfully saved document
SaveUnitsOfMeasureSuccess= Successfully save units of measures

UpdateBillingCycleSuccess = Successfully switched to {{billingCycle}} billing
SaveAddressesSuccess = Successfully saved addresses
SaveBillOfMaterialsSuccess = Successfully saved bill of materials
SavePaymentMethodSuccess = Successfully saved payment method
SaveBoxesSuccess = Successfully saved boxes
SaveDocumentSuccess = Successfully saved document
SaveLocationSettingsSuccess = Successfully saved location settings
SaveUnitsOfMeasureSuccess= Successfully save units of measures
SaveVariantSuccess = Successfully saved variants

SuccessAddedToReorderList = Item(s) successfully added to the reorder list
SuccessApproved = Successfully approved
SuccessActivated = Successfully activated
SuccessArchived = Successfully archived
SuccessClosed = Successfully closed
SuccessCopyTemplateToAccount = Successfully copied template(s) to your account
SuccessComplete = Succesfully completed
SuccessConfirmed = Successfully confirmed
SuccessDeactivated = Successfully deactivated
SuccessDeleted = Successfully deleted
SuccessDeletedComment  = Successfully deleted comment
SuccessGeneratePos = Successfully generated purchase orders
SuccessGeneratePosFromReorders = Your purchase orders are being generated; you will see them in your account soon
SuccessGenerateTransfer = We are creating your transfer. It will post to your account soon if you have enough inventory available.
SuccessGenerateTransfer.AllowNegativeInventory = We are creating your transfer. It will post to your account soon.
SuccessInvoicesGenerated = Invoices successfully generated
SuccessMerged = Successfully merged
SuccessOpened = Successfully opened
SuccessRefund = Succesffully refunded
SuccessSave = successfully saved
SuccessSync = Successfully added to sync
SuccessSent = Email successfully sent
SuccessUnarchived = Successfully unarchived
SuccessUnconfirmed = Successfully unconfirmed
SuccessRemovePaymentInfo = Successfully removed payment info
SuccessDisconnectShopify = Successfully disconnected from Shopify
SuccessProduceAll = We are processing all the assembly item lines in the background. You will receive a notification when this completes.
SuccessTest.alert = The alert ran successfully 
SuccessTest.ftpconnection = The FTP connection ran successfully.
SuccessUnlocked = Successfully unlocked
SuccessVoid = Succesfully voided UPS shipment
SuccesUpdate = Succesfully updated
SuccessUpdatePlan = Succesfully updated plan

PaymentInformationClearError = There has been an error in clearing your payment information. Please contact your account administrator or support@sosinventory.com for assistance.
PaymentInformationClearSuccess = Your payment information has been successfully cleared.
SuccessRestoreDefaultTemplates = Default templates successfully restored
SuccessInvoicesGenerated = Invoices successfully generated
SuccessMerged = Successfully merged
SuccessOpened = Successfully opened
SuccessRestore = Successfully restored
SuccessSave = successfully saved
SuccessSent = Email successfully sent
SuccessSync = Successfully added to sync
SuccessUnarchived = Successfully unarchived
SuccessUnconfirmed = Successfully unconfirmed

updateEdi = All shipments updated
VariantTypeMismatch = All variant item types must match master item type
VariantOfAnotherItem = A linked item is already the variant of another item

RetrieveItemFailed = Temporarily unable to retrieve information about the inventory item you selected. Vendor part number and unit price have not been updated.

AvailableForSale = Available for sale
BillDue = Bill due
CustomField = Custom field
InvoiceDue = Invoice past due
LotExpiration = Lot expiration
LowInventory = Low inventory
SalesOrderDue = Sales order due
SalesReceiptDue = Sales receipt due
TaskDue = Task due
SendAnEmail = Send an email
NotifyAUser = Notify a user
SendAText = Send a text
Always = Always
Daily = Daily
Never = Never
Hourly = Hourly
Weekly = Weekly
InStock = In stock
DefaultIsAllCategories = Default is all categories
DefaultIsAllLocations = Default is all locations

Available = Available
OnHand = On hand

MutipleWorksheets = This file contains multiple worksheets. Please select the one you'd like to preview.

[upsShipment]
shippingOption.UpsGround ="UPS® Ground"
shippingOption.UpsNextDayAir = "UPS Next Day Air®"
shippingOption.UpsNextDayAirSaver = "UPS Next Day Air Saver®"
shippingOption.UpsNextDayAirEarlyAM = "UPS Next Day Air® Early A.M.®"
shippingOption.Ups2ndDayAir = "UPS 2nd Day Air®"
shippingOption.Ups2ndDayAirAM = "UPS 2nd Day Air A.M.®"
shippingOption.Ups3DaySelect = "UPS 3 Day Select®"

confirmationOption.Standard = Standard (email or online)
confirmationOption.Printed = Printed, no signature (extra fee)
confirmationOption.SignatureRequired = Signature required (extra fee)
confirmationOption.AdultSignatureRequired = Adult signature required (extra fee)

rateOption.Standard = Standard rates
rateOption.Daily = Daily rates
rateOption.Retail = Retail rates

UPSRates = UPS rates
Service = Service
GuaranteedBy = Guaranteed by
Cost = Cost

packageOption.YourPackaging = Your packaging
packageOption.UPSLetter = UPS letter
packageOption.Tube = Tube
packageOption.PAK = PAK
packageOption.UPSExpressBox = UPS express box
packageOption.Pallet = Pallet
packageOption.SmallExpressBox = Small express box
packageOption.MediumExpressBox = Medium express box
packageOption.LargeExpressBox = Large express box

CompareTimeAndCost = Compare time and cost
UpsTrademarkDescription = UPS, the UPS Shield trademark, the UPS Ready mark and the Color Brown are trademarks of United Parcel Service of America, Inc. All Rights Reserved.
UPSShipmentConfirmation = UPS shipment confirmation
TotalCharges = Total charges
UseThisService = Use this service

ConfirmUpsShipment = Confirm UPS shipment
estimated = estimated
ShipNow = Ship now
ShipTo = Ship to
ShipFrom = Ship from
ShippingDetails = Shipping details
EstimatedDelivery = Estimated delivery

ServiceType = Service type
TotalCharges = Total charges
BillTo = Bill to

GoBack = Go back

Requirement.Weight = Weight
Requirement.Dimensions = Dimensions (L × W × H)
Requirement.ToAddress = To address (zip, state)
Requirement.FromAddress = From address (zip, state)
Requirement.UpsAccount = UPS account

CompleteRequiredFields = Complete the required fields to view service options:


[tooltip]
AddToReorderList = Select at least one row in order to add the corresponding item(s) to the reorder list
AddToSync = Send the transaction(s) for this {{objectType}} on the next sync with QuickBooks
ApplyNewDocument = You must first select a document.
BillWithParent = This setting applies only to sub-customers. For others, it is ignored.

CannotTransferFromAllLocations = Please select a specific location to generate a transfer
ClickToExpand = Click to expand
ClickToGoToList = Click to go to list
ClickToRetrieveAvailable = Click here to retrieve available inventory quantity as of the transaction date
Collapse = Collapse
CopyThisItem = Copy this item into a new one
CopyToClipboard = Copy to clipboard
CreateTask = Create task
CurrencyDisabled = This {{objectType}} is in QuickBooks, and QuickBooks does not allow the currency of an existing {{objectType}} to be changed.

Delete = Delete this item receipt
DownloadDisplayedList = Download displayed list
EditThisLine = Edit this line
ExpandToEdit = Expand to edit
favorite = favorite
GeneratePurchaseOrders = Select at least one row in order to generate the corresponding purchase order(s)
GenerateTransfer = Select at least one row in order to generate the corresponding transfer(s)
History = Show history of this transaction

LineIsAlreadyEditable = Line is already editable
NoSelectableReportColumns = This report does not have selectable columns
NotSyncedQBO = This {{objectType}} has not synced with QuickBooks.
Pdf = Print or download item receipt
ProduceAll = This will produce any assemblies that are not lot or serial tracked on inputs or outputs.
ReturnToVendor = Create return to vendor
PODisabled = This PO has been closed. You can not edit it unless you reopen it first.

SaveDisabled = Save will be available when the update completes
SelectBinFirst = Select a bin first.
SelectCustomerFirst = You must first select a customer
SelectTermsFirst = Select terms to enable vendor bill due date calculation
ShowOnForms = If this box is checked, the {{objectType}} will show in the dropdown list on purchase forms. If the box is unchecked, the {{objectType}} will not show. This allows you to refine your vendor list to remove extraneous {{objectType}}s that are not used in normal operations.
SortTableByNameThenQuantity = Sorts item table by item name, then quantity ascending
SyncComplete = Sync complete
SyncError =  Sync error. Please refer to the sync errors menu option (by clicking on this icon) for more information.

Taxable = At the present time, QuickBooks does not allow 3rd-party apps to update the tax-exempt setting in their automated tax tool. You will need to update it manually there.
ToggleDiscountTaxable = Click to take discount after tax.
ToggleDiscountNotTaxable = Click to take discount before tax.
UseAsTemplate = Copy this {{objectType}} into a new one
unfavorite = unfavorite

[customer]
CreditHold = Credit hold
FoundUsVia = Found us via
BusinessLicense = Business license
ResaleNumber = Resale number
BillingAddress = Billing Address
ShippingAddress = Shipping Address
NewCustomer = New Customer
ContractorNumber = Contractor Number
PortalPassword = Portal Password
CustomerType = Customer Type
ParentCustomer = Parent Customer
BillWithParent = Bill with parent
Taxable = Taxable
LineItemError.Name = Name field is required.
SameAsBilling = Same as billing
GenerateNewPassword = Generate new password
labelCustomerNotes = Customer notes
AddNewCustomer = Add new customer
AddMoreCustomer = Add more customer details
CreditHold = This customer is on a credit hold.

taxExemptReason.FederalGovernment = Federal government
taxExemptReason.StateGovernment = State government
taxExemptReason.LocalGovernment = Local government
taxExemptReason.TribalGovernment = Tribal government
taxExemptReason.CharitableGovernment = Charitable organization
taxExemptReason.ReligiousOrganization = Religious organization
taxExemptReason.EducationalOrganization = Educational organization
taxExemptReason.Hospital = Hospital
taxExemptReason.Resale = Resale
taxExemptReason.DirectPayPermit = Direct pay permit
taxExemptReason.MultiplePointsOfUse = Multiple points of use
taxExemptReason.DirectMail = Direct mail
taxExemptReason.AgriculturalProduction = Agricultural production
taxExemptReason.IndustrialProductionManufacturing = Industrial production / manufacturing
taxExemptReason.ForeignDiplomat = Foreign diplomat
taxExemptReason.Other = Other

isValid.Email = You must enter a valid email.
isValid.Website = Invalid URL.
isValid.taxExemptReasonId = Please select a valid tax exempt reason


[addOrder]
SelectPO = Select PO
SelectRental = Select rental
SelectOrder = Select order
NoneAvailable = None available
SelectRMA = Select RMA

[estimate]
labelNumber = "Estimate reference #"
Error.Customer = You must select a customer.

[invoice]
labelNumber = "Invoice reference #"

[frmLabel]
Abbreviation = Abbreviation
AcceptedBy = Accepted by
AcceptedDate = Accepted date
Account = Account
AccountingBillDueDateCalculation = Accounting bill due date calculation
AccountingTransactionType = Accounting transaction type
AccountDescription = Account description
AccountNumber = "Account #"
AdditionalComments = Additional comments
AdditionalHandling = Additional handling
AddOrder = Add order
AddRental = Add rental
AddPurchaseOrder = Add purchase order
AddRMA = Add RMA
AdjustmentNumber = "Adjustment #"
AdminApiAccessToken = Admin API access token
ShopifyClientId = Client ID
ShopifyClientSecret = Client secret
AlertMethod = Alert method
AlertOn = Alert on
AlertType = Alert type
Administrator = Administrator
AlwaysShippable = Always shippable
AssetAccount = Asset account
AssignedToUser = Assigned to
AssignedUponSave = Assigned upon save
AsOf = As of
AtLocation = At location
Attach = Attach
AttachedTo = Attached to
AutoSerialLots = Auto serial/lot numbers

Barcode = Barcode
BasedOnItemReceiptDate = Based on item receipt date
BasedOnEnteredInvoiceDate = Based on entered invoice date
BaseUnit = Base unit
BaseSalesPrice = Sales price
BigCommerceAccessToken = BigCommerce access token
BigCommerceApiPath = BigCommerce API path
BigCommerceClientId = BigCommerce client ID
Bin = Bin
BinNumber = Bin number
BinTracking = Bin tracking
BlanketPO = Blanket PO

Category = Category
CarrierCode = Carrier code
Cart = Cart
Calculation = Calculation
CalculateVendorBillDueDate = Calculate vendor bill due date
Channel = Channel
City = City
Class = Class
ClickToLetCustomersPayOnline = Click here for more information about letting customers pay online
CogsAccount = COGS account
Comment = Comment
CommissionAmount = Commission amount
CommissionExempt = Exempt from commission
CommissionRate = Commission rate
CompanyId = Company ID
ConfirmEmail = Confirm email
ConfirmNewPassword = Confirm new password
CheckNumber = "Check #"
Completed = Completed
CompleteBy = Complete by
Comment = Comment
CommissionAmount = Per sale commission
Company = Company
CompanyOrName = Company or name
ComparisonValue = Comparison value
Country = Country
Contact = Contact
CreateBill = Create bill
CreateVendorCredit = Create vendor credit
CreateCreditMemo = Create credit memo
ContractManufacturing = Contract manufacturing
Currency = Currency
CustomerMessage = Customer message
Customer = Customer
CustomerText = Customer text
CustomerPartNumber = Customer part number
CustomerPaymentLink = Customer payment link
CustomerPO = Customer PO

Date = Date
DateTime = Date/time
DataType = Data type
Date = Date
DateDiscountPercent = Date discount percent
DiscountDayOfMonth = Discount day of month
DayOfNextMonth = Day of Next Month
DayNextMonthDays = Day next Month days
DayOfMonthDue = Day of month due
DaysBeforeDueDate = Days before due date
DaysPriorToExpiration = Days prior to expiration
Dimensions = Dimensions
DiscountPercent = Discount percent
DiscountDays = Discount days
DueDays = Due days
DueNextMonthDays = Due next month days
Duration = Duration
DeclaredValue = Declared value
Default = Default
DefaultBin = Default bin
DefaultClass = Default class
DeletedTheLinkedNotification = Delete the linked notification
DeliveryConfirmation = Delivery confirmation
Department = Department
DepositAmount = Deposit amount
DepositPercent = Deposit %
DepositAccount = Deposit account
Description = Description
DimensionUnit = Dimension unit
DimensionsUnit = Dimensions unit
DocumentAdd = Add document
DocumentChange = Change document
DropShip = Drop ship
DueDate = Due date

Email = Email
Enabled = Enabled
EstimateNumber = "Estimate #"
ExchangeRate = Exchange rate
ExpenseAccount = Expense account
ExpectedDate = Expected date
ExpirationDate = Expiration date
ExpectedShip = Expected ship

Field = Field
File = File
FilterByItem = Filter by item
FirstName = First name
FlatDiscount = Flat discount
ForceToShipStation = Force to ShipStation
ForCustomer = For customer
FormType = Form type
FromLocation = From location
FromBin = From bin
FtpPassword = FTP password
FtpUsername = FTP username

HasVariants = Has variants
Height = Height
Host = Host

Importing = Importing
InboundRemotePath = Inbound remote path
IncomeAccount = Income account
Interval = Interval
InvoiceNumber = "Invoice #"
Item = Item
ItemNameContains = Item name contains
Is = Is

Job = Job
JobAddress = Job address
JobNumber = Job number
Justification = Justification

KeepOnFile = Keep on file

LastName = Last name
LeadTime = Lead time
Length = Length
ListValues = List values
Location = Location
Lot = Lot
LotNumber = Lot number
LotTracking = Track lot numbers

MaxStock = Max stock
MarkupPercent = Markup %
Message = Message
MerchandiseDescription = Merchandise description
MinimumPrice = Minimum price
Multiplier = Multiplier
MobileCarrier = Mobile carrier

Name = Name
NewPassword = New password
NonNettable = Non-nettable
Notes = Notes
Number = Number

OrderNumber = "Order #"
OrderStage = Order stage
OutboundRemotePath = Outbound remote path
OverrideDescription = Override description

PackageInfo = Package info
PackageType = Package type
Password = Password
Payment = Payment
PaymentNumber = "Payment #"
PaymentMethod = Payment method
PayPalPaymentAddress = PayPal payment address
PayPalFeeAccount = PayPal fee account
PayPalIncomeAccount = PayPal income account
PercentCommission = "Commission %"
Phone = Phone
PhoneNumber = Phone number
PickBy = Pick by
PlaceOfSupply = Label of supply
PoNumber = "PO #"
PostalCode = Postal code
PickTicketNumber = "Pick ticket #"
PreferredVendor = Preferred vendor
Price = Price
PriceTier = Price tier
Priority = Priority
ProcessNumber = "Process #"
PromotionCode = Promotion code
ProductionForms = Production forms
PurchaseCost = Purchase cost
PurchaseOrderDate = Purchase order date
PurchaseTaxCode = Purchase tax code
PurchasingForms = Purchasing forms

Quantity = Quantity
Question = Question

Reason = Reason
Rate = Rate
Recalled = Recalled
ReceiptNumber = "Receipt #"
ReferenceNumber1 = Reference number 1
ReferenceNumber2 = Reference number 2
RentalNumber = "Rental #"
RentalReturnNumber = "Rental return #"
ReturnNumber = "Return #"
ResidentialAddress = Residential address
RestrictCustomers = Restrict customers
ReorderPoint = Reorder point
RepeatAlert = Repeat alert
RMANumber = "RMA #"
RtvNumber = "RTV #"

SalesForms = Sales forms
SalesChannel = Sales channel
SaleNumber = "Sale #"
SalesReceiptDepositAccount = Sales receipt deposit account
SalesRep = Sales rep
SalesTaxCode = Sales tax code
SalesTaxRatePercent = "Sales tax rate %"
SelectVendorBillDate = Select the vendor bill date
SendForSku = Send for SKU
SendForDescription = Send for description
SequenceNumber = "Sequence #"
SerialNumber = Serial number
SerialNumberAbbreviated = S/N
SerialTracking = Track serial numbers
Service = Service
ShipmentNumber = "Shipment #"
Share = Share
ShippingOptions = Shipping options
Signature = Signature
Sku = SKU
SortOrder = Sort order
StatusMessage = Status message
StatusUrl = Status URL
ShipBy = Ship By
ShipDate = Ship date
ShipFrom = Ship from
Shipments = Shipments
ShipMethod = Ship method
ShippedVia = Shipped via
ShippingCost = Shipping cost
ShippingDiscountTaxCode = Shipping/discount tax code
ShippingDiscountTax = 'Shipping/discount tax %'
ShipStationCarrier = ShipStation carrier
ShipStationService = ShipStation service
ShipTo = Ship to
ShowOn = Show on
Shop = Shop
ShopifyApiKey = Shopify API key
ShopifyApiPassword = Shopify API password
ShopifyAppType = Shopify app type
StartDate = Start date
State = State
Status = Status
Subject = Subject
SyncWithQuickBooks = Sync with QuickBooks
StartDate = Start date
StateProvince = State/province
Status = Status

Tags = Tags
Taxable = Taxable
TaxExemptReason = Tax exempt reason
TaxCode = Tax code
TaxPercent = 'Tax %'
Template = Template
Terms = Terms
TrackingNumber = Tracking number
ToBin = To bin
ToLocation = To location
ToVendor = To vendor
TrackingNumber = Tracking number
TransactionLocation = Transaction location
TransactionType = Transaction type
TransferNumber = "Transfer #"
Type = Type

Unitprice = Unit price
Units = Units
UpdateDefaultCosts = Update default costs
UpdateInventoryInShopify = Update inventory in Shopify
UpdateInventoryInBigCommerce = Update inventory in BigCommerce
User = User
UpsAccount = UPS account
UpsAccountNumber = UPS account number

UseSosOrderNumber = Use SOS order number
UseCommonCustomer = Use common customer
UpdateInventory = Update inventory

Value = Value
Vendor = Vendor
VendorInvoiceDate = Vendor invoice date
BillDueDate = Bill due date
VendorBillDate = Vendor bill date
VendorNotes = Vendor notes
VendorMessage = Vendor message
VendorPartNumber = Vendor part number
Volume = Volume
VolumeUnit = Volume unit

Warranty = Warranty
WarrantyEnd = Warranty end
WarrantyStart = Warranty start
Weight = Weight
WeightUnit = Weight unit
WhenAAn = When a/an
WhereDidYouHearAboutUs = Where did you hear about us?
WithChannel = With channel
WithPriority = With priority
Width = Width
WorkCenter = Work center
WorkOrderNumber = "Work order #"
Worksheet = Worksheet

[columns]
colon.Address = Address:
colon.Bin = Bin:
colon.Expiration = Expiration:
colon.FromBin = From bin:
colon.Lot = Lot:
colon.Serials = S/N:
colon.Template = Template:
colon.ToBin = To bin:
colon.Worker = Worker: 

Total = Total

Abbreviation = Abbreviation
AccountNumber = Account number
AccountType = Account type
Action = Action
Active = Active
Account = Account
Address = Address
AdjustCostBasisBy = Adjust cost basis by
AdjustQuantityBy = Adjust qty by
AdjustmentAccount = Adj Acct
AlertMethod = Alert method
Admin = Admin
AltPhone = Alt phone
Amount = Amount
App = App 
Application = Application
AppliedTo = Applied to
AppliedToWO = Applied to WO
Approved = Approved
ApplyToRMA = Apply to RMA
Assembly = Assembly
AssignedTo = Assigned to
AssetAccount = Asset account
AuthCode = Auth code
Available = Available

Backordered = Backordered
Barcode = Barcode
BaseUOM = Base UOM
Bill = Bill
Billable = Billable
BillDate = Bill date
Bin = Bin
BinNumber = Bin number
BinTracking = Bin tracking
BillWithParent = Bill with parent
Balance = Balance
BillingAddress = Billing address
BlanketPO = Blanket PO
BusinessLicense = Business license
Billing = Billing

CarrierCode = Carrier code
CreditAmount = Credit amount
CanShip = Can ship
Category = Category
Class = Class
CostBasis = Cost basis
Comment = Comment
CommissionRate = Commission rate
Company = Company
Contact = Contact
Contents = Contents
Cost = Cost
CostEach = Cost each
Currency = Currency
CardOnFile = Card on file
CustomerType = Customer type
CustomerAddress = Customer address
Currency = Currency
CogsAccount = Cogs account
Confirmed = Confirmed
Channel = Channel
CostBasis = Cost basis
AvgValue = Avg value
CustomerPO = Customer PO
ContractManufacturing = Contract Manufacturing
CustomerNotes = Customer notes
CustomerMessage = Customer message
ContractorNumber = Contractor number
CreditHold = Credit hold
ComissionExempt = Commision exempt
Comment = Comment
Credits = Credits
CustomerPartNumber = Customer part number
CanShip = Can Ship
Customer = Customer

DataType = Data type
DateActivated = Date activated
Debits = Debits
DefaultBin = Default bin
DefaultUOM = Default UOM
Date = Date
Default = Default
Description = Description
Documents = Documents
DueDate = Due date
Discount = "Discount %"
Due Date = Due date
DepositAccount = Deposit account
DefaultTax = Default Tax
DateTime = Date/Time
Delete = Delete
DropShip = Drop ship
Department = Department
Deposit = Deposit
DisplayName = Display name

Email = Email
Entity = Entity
ETA = ETA
ETS = ETS
Enabled = Enabled
Event = Event
ExpDate = Exp date
ExchangeRate = Exchange rate
ExpectedYield = Expected yield
ExpenseAccount = Expense account
Expiration = Expiration

Fax = Fax
FirstName = First name
For = For
FromLocation = Location
ForOrder = For order
FoundUsVia = Found us via
FreightClass = Freight class
From = From
FullName = Full name
FullName = Full name
FromLocation = From location
FromJob = From job

GoTo = Go to

Height = Height
HireDate = Hire date
Image = Image
Instructions = Instructions
Item = Item
Income = Income 
InStock = In stock
ItemToMake = Item to make
ItemDescription = Item description
InvoiceDate = Invoice Date
Invoices = Invoices
Invoiced = Invoiced
IncomeAccount = Income account
Interval = Interval

Job = Job
Line = Line
FromJob = From job
Last4 = Last 4
LastLogin = Last login
LastName = Last name
LastUpdatedBy = Last updated by
Line = Line
LinkedItem = Linked item
ListPrice = List price
Location = Location
Locked = Locked
LotNumber = Lot number
LotTracked = Lot tracked
LeadTime = Lead time
Length = Length
LinkedTo = Linked to

MaxStock = Max stock
Margin = "Markup %"
Message = Message
Method = Method
Memo = Memo
MemoDate = Memo date
Minutes = Minutes
Mobile = Mobile
Monitor = Monitor
MinimumSalesPrice = Minimum sales price
NewQuantity = New quantity
Name = Name
Number = Number
Net = Net
NetTotal= Net total
NonNettable = Non-nettable
Notes = Notes
Number = Number

Object = Object
ObjectType = Type
ObjectAndIdentifier = Object
OldQuantity = Old quantity
OnHand = On hand
OnShortOrder = On SO
OnSO = On SO
OnSR = On SR
OnPO = On PO
OnWO = On WO
OnRMA = On RMA
OnRental = On rental
OpenAmt = Open Amt
OpenAmount = Open Amt
Ordered = Ordered
OriginalAmount = Original amount

Parent = Parent
PartNumber = "Part #"
Payment = Payment
Payments = Payments
PaymentMethod = Payment method
PercentCommision = "Commission %"
PerUnitCommission = Per unit commission
Phone = Phone
PhoneNumber = "Phone #"
PickBy = Pick by
Picked = Picked
Priority = Priority
Price = Price
Profile = Profile
PickQuantity = Pick qty
PickTickets = Pick tickets
Placeholder = Placeholder
PmtRef = Pmt ref
PmtMethod = Pmt method
PriceTier = Price tier
ProduceAll = Produce all
Produced = Produced
ProcessTemplate = Process template
PurchaseDescription = Purch description
PurchaseDate = Purchase date
PurchasePrice = Purch price
PurchaseCost = Purchase cost

QuickBooksMessage = QuickBooks message
Quantity = Quantity
QuantityUsed = Qty used
QuantityToBuild = Qty to build
Qty = Qty
QtyDiff = Qty diff

Rate = Rate
RateName = Rate name
RatePercent Rate percent
Rates = Rates
Ratio = Ratio
Reason = Reason
Recalled = Recalled
Received = Received
ReferenceNumber = "Ref #" 
Refund = Refund
Request = Request
ReorderPoint = Reorder pt
Repeat = Repeat
RestockValue = Restock value
Restore = Restore
ResaleNumber = Resale number
Reset = Reset
Returned = Returned
Returns = Returns
Revoke = Revoke

SalesPrice = Sales price
SalesRep = Sales rep
Selection = Selection
Sequence = Sequence
SerialTracked = Serial tracked
ShipBy = Ship by
Shipments = Shipments
ShipDate = Ship date
ShipMethod = Ship method
ShippingAddress = Shipping address
Shipped = Shipped
Shipping = Shipping
ShipQuantity = Ship qty
ShipTo = Ship to
Signature = Signature
SortOrder = Sort order
SosPmt = SOS pmt
Status = Status
Stage = Stage
StatusMessage = Status Message
StartDate = Start date
Step = Step
ShippingCost = Shipping cost
SyncWithQuickBooks = Sync with QuickBooks
ShowOnSales = Show on sales
ShowOnPurchasing = Show on purchasing
ShowOnProduction = Show on production
SerialNumber = Serial number
Shipments = Shipments
Sku = SKU
Sync = Sync
SyncError = Sync error
System = "Sys #"
ShowOn = Show on
Shipping = Ship to
TotalAmount = Total Amount

Tags = Tags
Target = Target
Tax = Tax
Taxable = Taxable
TaxCode = Tax code
Terms = Terms
TimeCreatedEdited = Time created/edited
To = To 
ToJob = To job
ToLocation = To location
TotalAmt = Total amt
TotalCharges = Total charges
TotalCost = Total cost
TotalCostBasis = Total cost basis
TotalInBuild = Total in build
TotalQty = Total qty
Tracking = Tracking
TrackingNumber = "Tracking #"
Transaction = Transaction
Transfer = Transfer
TrackingNumber = Tracking number
TrackingNumber = Tracking number
Trigger = Trigger
TxnDate = Txn date
TxnId = Txn Id
TxnCostPerUnit = Txn cost/unit
TxnQty = Txn qty
Type = Type

Unit = Unit
UOM = UOM
UnitPrice = Unit price
Url = URL
UsedPer = Used per
UpdateShopify = Update Shopify
UpdateBigCommerce = Update Big Commerce
User = User
UploadedDate = Uploaded date
UploadedBy = Uploaded by
UpsAccount = UPS account

ValueDiff = Value diff
VariantName = Variant name
Variance = Variance
Vendor = Vendor
VendorMessage = Vendor message
VendorNotes = Vendor notes
VendorPartNumber = Vendor part number
Void = Void
Voided = Voided
Volume = Vol

Warranty = Warranty
WarrantyStart = Warranty start
WarrantyEnd = Warranty end
Waste = Waste
Weight = Weight
When = When
WhichOne = Which one
Who = Who
Width = Width
Workcenter = Work center
WorkOrder = Work order
WorkCenter = Work center
Yield = Yield

[quickView]
SUBTOTAL = SUBTOTAL
OTHERCOSTS = OTHER COSTS
DISCOUNT = DISCOUNT
SHIPPING = SHIPPING
TAX = TAX
TOTAL = TOTAL
PAYMENTS = PAYMENTS
BALANCEDUE = BALANCE DUE
ShowItemNames = Show item names
ShowBackorderedSwitch = Show backordered quantity

[entityActions]
Activate = Activate
AddToReorderList = Add to reorder list
AddToSync = Add to sync
Addresses = Addresses
Approve = Approve
BatchActionDisabled = Select at least one {{objectType}}
BillOfMaterials = Bill of materials
Boxes = Boxes

ChargeCardOnFile = Charge card on file
ClearCache = Clear cache
CreateReturnToVendor = Create return to vendor
CreateTransfer = Create transfer
Close = Close
Confirm = Mark as confirmed
CreateDropShip = Create drop-ship purchase order
CreateInvoice = Create invoice
CreateReturnUPSShipment = Create return UPS shipment
CreateReturnToVendor = Create return to vendor
CreatePurchaseOrder = Create purchase order
CreateSalesOrder = Create sales order
CreateSalesReceipt = Create sales receipt
CreateSubCustomer = Create sub-customer
CreateTransfer = Create transfer
CopyThisItem = Copy this item

Disconnect = Disconnect
Deactivate = Deactivate
Disassemble = Disassemble
EdiImport = Import via EDI
Get = Get (copy to account)
Invoices = Generate invoices
Job = Create job
JobDashboard = Job dashboard
LocationSettings = Location settings
MarkAsComplete = Mark as complete
Open = Open
PickTicket = Create pick ticket
PrintLabel = Print label
ProfitLoss = View profit/loss
PurchaseOrders = Generate purchase orders
QuickView = Quick view

Receive = Receive
RemovePaymentInfo = Remove payment info
Refund = Refund
ReceivePayment = Receive payment
Rental = Create rental
RentalReturn = Create rental return
RentalHistory = Rental history
Restore = Restore
Return = Create return
RMA = Create RMA
Shipment = Create shipment
ShipUps = Ship via UPS
ShowCustomerHistory = Show customer history
ShowHistory = Show transaction history
ShowVendorHistory = Show vendor history
TestNow = Test now

Unconfirm = Mark as unconfirmed
Unlock = Unlock
UnitsOfMeasure = Units of measure
UpdateEdi = Update via EDI
Unconfirm = Mark as unconfirmed
UseAsTemplate = Use as template
Variants = Variants
ViewInQuickBooks = View in QuickBooks
WorkOrder = Create work order

[saveActions]
More = More
SaveAndClose = Save and close
SaveAndGoTo = Save and go to
SaveAndKeepEditing = Save and keep editing
SaveAndNew = Save and new
SaveAndPDF = Save and PDF
SaveAndPrintLabel = Save and print label
SaveAndSend = Save and send
SaveAndShip = Save and ship
Next = Next

ShipNow = Ship now
ShipNowAndGoTo = Ship now and go to
ShipNowAndPDF = Ship now and PDF

[auditAction]
Accepted = Accepted
Added = Added
Edited = Edited
Deleted = Deleted
Activated = Activated
Restored = Restored
Logged In = Logged In
Synchronized with QuickBooks = Synchronized with QuickBooks
Emailed = Emailed
Received = Received
Shipped = Shipped
Built = Built
Used To Build = Used to build
Returned = Returned
ReturnedToVendor = Returned to vendor

[mobile]
ClickToInstall =  Click the image below to install SOS Inventory on a mobile (iOS) device.
OrSearchAppStore = Or search in the Apple app store for SOS Inventory.
MobileApp = Mobile app

[imgAlt]
AppStoreBadge = App store badge

[uom]
EnterAllUnits = Enter all the possible units of measure for this item besides the base unit.
ConversionRatio = The conversion ratio is the number of base units in the specified unit. For example, if you sell 12 widgets in a case, the ratio for the case would be 12.

[auditObject]
adjustment = inventory adjustment
buildassembly = build
build = build
estimate = estimate
invoice = invoice
itemreceipt = item receipt
lot = lot
payment = payment
pickticket = pick ticket
purchaseorder = purchase order
process = process transaction
rental = rental
rentalreturn = rental return
return = return
returntovendor = return to vendor
rma = RMA
salesorder = sales order
salesreceipt = sales receipt
shipment = shipment
transfer = transfer
workorder = work order

[serialLotEvent]
adjustment = Adjusted
build.in = Used in build
build.out = Built
itemreceipt = Received
pickticket = Picked
process.in = Used in process
process.out = Output of process
rental = Rented
rentalreturn = Returned from rental
return = Returned from customer
returntovendor = Returned to vendor
salesorder = Sold
shipment = Shipped
transfer = Transferred

[itemEvent]
adjustment = Adjustment
build.in = Used to build
build.out = Build
itemreceipt = Receipt
process.in = Used to process
process.out = Process
rental = Rental
rentalreturn = Return from rental
return = Return
returntovendor = Return to vendor
shipment = Shipment
transfer = Transfer

[document]
AddDocument = Add document
AddNewDocument = Add new document
AssociatedDocuments = Documents associated with this {{objectType}}:
FileSelector = File selector
Description = Description
Documents = Documents
DragDropDocument = Drop file here, or use the "file selector" button.
DropDocumentHere = Drop the document here ...
FileName = File name
NoAssociatedDocuments = There are no documents attached to this {{objectType}}
Share = Share
SearchPlaceholder = Search for/add a document
DuplicateFileName = Duplicate file name. Rename the file and retry.
SaveFirst = You can add and manage attached documents after saving this {{objectType}}.

[beta]
Maintenance.1 = V9 beta is currently down for maintenance. Click
Maintenance.2 = here
Maintenance.3 = to use our V8 product.

NotFinished = This page has not yet been finished for the version 9 beta.
GoToProduction = If you need this functionality now, please go back to our current production version at 

[colon]
Comment = Comment: 
Document = Document:
CurrentQuantity = Current quantity:
CurrentQuantity = Current quantity: 
Date = Date:
Document = Document:
Location = Location:
PulledBy = Pulled by:
ReceivedBy = Received by:
Terms = Terms:
Total = Total:
Vendor = Vendor:

[carat]
noVendor = <no vendor>
noCategory = <no category>

[auth]
Invalid = Login failed. Please verify that your email address and password are correct.
Locked = For your protection, this user account has been locked. Please contact your account administrator or support@sosinventory.com for assistance.
NonUser = You are not currently a user with any companies for SOS Inventory. Please contact your account administrator or support@sosinventory.com for assistance.
IntuitError = An error occurred when trying to log in via Intuit. Please try again or contact support at support@sosinventory.com.

IntuitEmailNotVerified.1 = Your email is not yet verified. Please 
IntuitEmailNotVerified.2 = login to your Intuit account
IntuitEmailNotVerified.3 = https://accounts.intuit.com/app/account-manager/security

[error]
CouldNotRetrieveItemLocationSettings = There was a problem retrieving the location settings.
CouldNotSaveUom = There was a problem saving the UOM selections.
CouldNotSaveAddresses = There was a problem saving the address selections.
global.1 = SOS Inventory has encountered an unexpected condition. If you retry and still receive this error and are not able to determine its cause, please email
global.2 = with details on the error received and the task you were attempting to accomplish.
global.3 = Alternatively, you can also call us at 817-422-5909 for assistance.
global.4 = Include the following error message:
InternalError = SOS Inventory has encountered an unexpected condition. If you retry and still receive this error and are not able to determine its cause, please email support@sosinventory.com with details on the error received and the task you were attempting to accomplish. Include the following error message: {{errorMessage}}
InternalError.WithSupportNumber = SOS Inventory has encountered an unexpected condition. If you retry and still receive this error and are not able to determine its cause, please email support@sosinventory.com or call 817-422-5909 with details on the error received and the task you were attempting to accomplish. Include the following error message: {{errorMessage}}
PositiveSerialAdjustment = You cannot add serial inventory using this form. Add serial inventory directly from the serial items list or the add menu, or use an item receipt.
RecordLoadError = There has been an error loading the {{objectType}} record.
TemplateDownloadError = There has been an error downloading the {{objectType}} template.
UpsRateLoadError = There has been an error loading UPS rates.
SaveLocationSettingsFailure = Location settings could not be saved
SaveVariantsFailure = Variants could not be saved
SubCustomerError = There has been an error creating the sub-customer for this customer.
GoToTheSOSInventoryHomePage = Go to the SOS Inventory home page
CustomFieldDateError.dd/MM/yyyy = Please review the {{name}} field, as it requires the date in dd/mm/yyyy format
CustomFieldDateError.M/d/yyyy = Please review the {{name}} field, as it requires the date in mm/dd/yyyy format
PriceTierEditLock = Please contact support at support@sosinventory.com or 817-422-5909 for new information on price tiers.
ErrorLinkingUpsAccount = There was a problem completing the UPS connection.
UpdatingHistoricalCost =  There has been an error updating historical cost.
CaptchaVerificationRequired = Captcha verification is required

[warning]
SwitchPriceTierType = By switching the type of this price tier, you will be clearing out your {{type}} data if you subsequently save. Are you sure?
PriceTierType.amountDiscount = amount discount
PriceTierType.percentDiscount = percent discount
PriceTierType.items = item quantity table

[isValid]
Abbreviation = You must enter a valid abbreviation.
address.NameFieldRequired = The name field is required on line {{lineNumber}}
AlertMethod = You must select a valid alert method.
AlertMethodEmail = You must enter a valid email address.
AlertMethodMobileNumber = You must enter a valid phone number.
AlertMethodMobileCarrier = You must select a valid mobile carrier.
CustomFieldType = You must select a valid alert on value.
CustomFieldField = You must select a valid field.
Customer = You must select a customer.
Date = You must enter a valid date and time.
Document = Saving document links requires a valid file.
Duration = You must enter a valid duration.
EnterCreditInfoThroughSOSPay = Please enter Credit payment info through SOS Pay.
EnterACHInfoThroughSOSPay = Please enter ACH payment info through SOS Pay.
FormTemplate.Content = Please enter a form template file.
LibraryTemplate.Content = Please enter a library template file.
FirstName = You must enter a valid first name.
InputItemRequired = You must enter at least one input line item, with an inventory item selected.

LineItem.MissingBin = You must select a bin on line {{lineNumber}}.
LineItem.QuantitySerialsMismatch = Quantity and serial number count don't match on {{lineType}} {{lineNumber}}.
LineItem.QuantityOverflow = Quantity on line {{lineNumber}} must have 8 or fewer digits left of the decimal point.
LineItem.UnitpriceOverflow = Unit price on line {{lineNumber}} must have 8 or fewer digits left of the decimal point.
LineItem.AmountOverflow = Amount on line {{lineNumber}} must have 8 or fewer digits left of the decimal point.
LineItemRequired = You must enter at least one line item, with an inventory item selected.

MissingSelection = You must select a transaction for each document link.

CancellationReason = Please select a reason for cancellation
AdditionalComments = Additional comments are required when "Other" is selected as the cancellation reason.
Email = You must enter a valid email.
EmailMismatch = The email addresses you entered do not match.
PasswordMismatch = The passwords you entered do not match.
NewPassword = New password must be at least 8 characters, and include at least one letter and at least one number.
OldPassword = You must enter the old password.
Location = You must select a valid Location.
LowInventoryCalculation = You must select a a valid calculation.
Name = Name field is required.
NoKitsInBuildOutputs = Kits cannot be used as the build output.
Number = You must enter a valid bin number.
OutputItemRequired = You must enter at least one output line item, with an inventory item selected.
PaymentMethodRequired = A payment method selection is required.
ProvideReferenceNumber = You must provide a reference number.
Question = Question field is required.
salesTransaction.Date = You must enter a valid date.
SequenceNumber = You must enter a valid sequence number.
DisplayOn = You must select at least one entity to show this custom field on.
SelectTarget = You must select a valid target for line {{lineNumber}}.
SortOrder = Sort order field is required.
Subject = Subject line is required.

upsShipment.deliveryConfirmationCode = You must select a valid delivery confirmation.
upsShipment.toPostalCode = You must select a valid "Ship to" postal code.
upsShipment.toCity = You must select a valid "Ship to" city.
upsShipment.toCompany = You must select a valid "Ship to" company.
upsShipment.fromCompany = You must select a valid "Ship from" company.
upsShipment.fromPostalCode = You must select a valid "Ship from" postal code.
upsShipment.fromLine1 = You must select a valid "Ship from" Line 1.
upsShipment.fromStateProvince = You must select a valid "Ship from" State.
upsShipment.toStateProvince = You must select a valid "Ship to" State.
upsShipment.toLine1 = You must select a valid "Ship to" Line 1.
upsShipment.fromCity = You must select a valid "Ship from" city.
upsShipment.packagingCode = You must select a valid package type.
upsShipment.rateType = You must select a valid rate type.
upsShipment.serviceCode = You must select a valid service.
upsShipment.upsAccount = You must select a valid UPS account.
upsShipment.weight = Packages must weight more than zero pounds.
upsShipment.length = Packages must have a length greater than zero.
upsShipment.width = Packages must have a width greater than zero.
upsShipment.height = Packages must have a height greater than zero.
upsShipment.returnMerchandiseDescription = You must enter a valid merchandise description.

ftpConnection.remoteHost = Host field is required.

uom.BaseUnitAlsoInTable = UOM on line {{lineNumber}} is the same UOM list as the base unit.
uom.DuplicateUom = Only one conversion per UOM selection is permitted.
uom.RatioRequired = Ratio value is required for line {{lineNumber}}.
uom.UomRequired = UOM selection is required for line {{lineNumber}}.
uom.ConversionMissingUom = Conversion on line {{lineNumber}} is missing the UOM selection.
uom.MustHaveBaseUnitSelected = A base unit selection is required.

amountDiscount = You must enter a valid flat discount value.
percentDiscount = You must enter a valid percent discount value.

import.objectType =  You must select a valid importing value.

upsAccount.number = Please enter a valid UPS account number
cart.ShopifyApiKey = You must enter a valid Shopify API key.
cart.ShopifyApiPassword = You must enter a valid Shopify API password.
cart.AdminApiAccessToken = You must enter a valid Admin API access token.
cart.ShopifyClientId = You must enter a valid Client ID.
cart.ShopifyClientSecret = You must enter a valid Client Secret.
cart.BigCommerceClientId = You must enter a valid BigCommerce Client ID.
cart.BigCommerceApiPath = You must enter a valid BigCommerce API path.
cart.TxnType = You must include a valid transaction type.
cart.Shop = You must enter a valid Shop value.

[modalHeader]
onSo = Items on sales order
onSr = Items on sales receipt
onPo = Items on purchase order
onRma = Items on RMA
onWo = Items on work order
onRental = Items on Rental

[reports]

export.header = Data export
report.header = Reports

AddToReorderList = Add to reorder list
AddToSync = Re-sync
DeleteThisReport = Are you sure you want to delete {{reportName}}?
Email = Send via email
CustomDesignation = Custom
GeneratePOs = Generate POs
GenerateTransfer = Generate transfer
GenerateTransferFor = Generate transfer for
selectedItems = selected item(s)
ReportTooLarge = This report is too large. Change the report settings to reduce the size.
ReportTooLargeToDisplay = This report is too large to display. Change the report settings or send it via email.
ProbableTimeOut = Report could not be fetched. Most likely cause is that generating the report timed out. Try setting one or more filters.
UnfavoriteThisReportHeader = Unfavorite
Unschedule = Unschedule
UnfavoriteThisReport = Are you sure you want to unfavorite {{reportName}}?
UnscheduleThisReport = Are you sure you want to unschedule the {{reportName}} report?
UnscheduleAndDelete = This will unschedule and delete {{reportName}}. If you only want to unschedule it, select it and unschedule it on the report page. Are you sure you want to proceed?

Report.MasterPurchaseReport = Master purchase report
Report.OpenPurchaseOrderDetail = Open purchase order detail
Report.PurchaseVariances = Purchase variances
Report.PurchasesByCategorySummary = Purchases by category - summary
Report.PurchasesByClassSummary = Purchases by class - summary
Report.PurchasesByCustomerSummary = Purchases by customer - summary
Report.PurchasesByDepartmentSummary = Purchases by department - summary
Report.PurchasesByItemSummary = Purchases by item - summary
Report.PurchasesByLocationSummary = Purchases by location - summary
Report.PurchasesByVendorSummary = Purchases by vendor - summary
Report.ReorderReport = Reorder report
Report.VendorEfficiency = Vendor efficiency
Report.WhereToBuy = Where to buy
Report.BinContents = Bin contents
Report.InventoryAging = Inventory aging
Report.InventoryStockStatus = Inventory stock status
Report.InventorySummary = Inventory summary
Report.InventoryTurnover = Inventory turnover
Report.InventoryValuation = Inventory value
Report.ItemAnalysis = Item analysis
Report.ItemMovement = Item movement
Report.ItemsInBins = Items in bins
Report.LotHistory = Lot history
Report.LotStockStatus = Lot stock status
Report.LotTraceability = Lot traceability
Report.LotsInBins = Lots in bins
Report.OverstockUnderstockReport = Overstock/understock report
Report.PhysicalInventoryWorksheet = Physical inventory worksheet
Report.SerialHistory = Serial unit history
Report.SerialsInBins = Serials in bins
Report.CommissionReport = Commission report
Report.MasterSalesReport = Master sales report
Report.OpenSalesOrderDetail = Open sales order detail
Report.OpenSalesReceiptDetail = Open sales receipt detail
Report.PriceBook = Price book
Report.ProfitLossByCustomer = Profit/loss by customer
Report.ProfitLossByItem = Profit/loss by item
Report.ProfitLossByJob = Profit/loss by job
Report.ReadyToInvoice = Ready to invoice
Report.SalesByCategorySummary = Sales by category - summary
Report.SalesByChannelSummary = Sales by channel - summary
Report.SalesByClassSummary = Sales by class - summary
Report.SalesByDepartmentSummary = Sales by department - summary
Report.SalesByCustomerSummary = Sales by customer - summary
Report.SalesByCustomerTypeSummary = Sales by customer type - summary
Report.SalesByItemSummary = Sales by item - summary
Report.SalesByLocationSummary = Sales by location - summary
Report.SalesByVendorSummary = Sales by vendor - summary
Report.SellThroughReport = Sell through
Report.BackorderReport = Backorder report
Report.FulfillmentEfficiency = Fulfillment efficiency
Report.ReadyToPickShip = Ready to pick/ship
Report.ShippingReport = Shipping report
Report.ExpandedBOM = Expanded BOM report
Report.OpenWorkOrderDetail = Open work order detail
Report.ProductionReport = Production report
Report.WhereUsed = Where used
Report.WorkInProgress = Work in progress
Report.ReconcileItemReceipts = Reconcile item receipts
Report.ReconcileJournalEntries = Reconcile journal entries
Report.ReconcileVendorCredits = Reconcile vendor credits
Report.OpenRentalDetail = Open rental detail
Report.RentalCalendar = Rental calendar
Report.DeletedItems = Deleted items
Report.TransactionsAssigned = Transactions assigned

Report.ExportAdjustments = Adjustments
Report.ExportBOMs = BOMs
Report.ExportBuilds = Builds
Report.ExportCustomers = Customers
Report.ExportEstimates = Estimates
Report.ExportInvoices = Invoices
Report.ExportLots = Lots
Report.ExportItemReceipts = Item receipts
Report.ExportJobs = Jobs
Report.ExportPayments = Payments
Report.ExportPickTickets = Pick tickets
Report.ExportPriceTiers = Price tiers
Report.ExportPurchaseOrders = Purchase orders
Report.ExportProcessTransactions = Process transactions
Report.ExportRentals = Rentals
Report.ExportRentalReturns = Rental returns
Report.ExportReturns = Returns
Report.ExportRTVs = Returns to vendors
Report.ExportRMAs = RMAs
Report.ExportSalesOrders = Sales orders
Report.ExportSalesReceipts = Sales receipts
Report.ExportSerials = Serial inventory
Report.ExportShipments = Shipments
Report.ExportTransfers = Transfers
Report.ExportWorkOrders = Work orders
Report.ExportUnitsOfMeasure = Units of measure
Report.ExportVendorItemCatalog = Vendor-item catalog
Report.ExportVendors = Vendors
Report.ExportItems = Items

WidgetText.Filters = Filters
WidgetText.Options = Options
WidgetText.Columns = Columns
WidgetText.RetrievingReport = Retrieving...
WidgetText.AddAllImportColumns = Add all columns required for import

Format.Excel = Excel (.xlsx)
Format.LegacyExcel = Legacy Excel (.xls)
Format.CSV = Comma-separated values (.csv)

RetrieveForms.ReportType = Report type
RetrieveForms.Send = SEND
RetrieveForms.Email = Email

Action.Retrieve = Retrieve your report
Action.Favorite = Favorite
Action.SaveAsCustom = Save customization as...
Action.SaveSettings = Save
Action.Schedule = Schedule
Action.ChangeSchedule = Change
Action.Unschedule = Unschedule
Action.RenameCustom = Rename

Schedule.Frequency = Frequency
Schedule.Time = Time
Schedule.Day = Day
Schedule.Email = Email
Schedule.FTP = FTP

Alert.Custom.ErrorRetrieving = There was a problem retrieving your custom reports.
Alert.Custom.DuplicateName = Please enter a new name for the report. Duplicate custom report names are not allowed.
Alert.Scheduled.ErrorRetrieving = There was a problem retrieving your scheduled reports.
Alert.Saved = Saved.
Alert.Scheduling.Success = Scheduled successfully.
Alert.Scheduling.Error = There was an error scheduling this report.
Alert.Scheduling.NoFrequency = Select a schedule frequency.
Alert.Scheduling.MissingTimeOfDay = Select a time of day.
Alert.Scheduling.MissingDayOfWeek = Select a day of the week.
Alert.Scheduling.MissingEmailOrFtp = Enter an email address and/or select an FTP server.
Alert.ConvertScheduledStandardError = There was a problem converting your scheduled standard report to a custom report.
Alert.Scheduling.Test.Successful = The report has been queued to run once. Check your email or ftp server.
Alert.Scheduling.Test.Unsuccessful = There was a problem queueing your report.

CustomScheduled.Name = Name
CustomScheduled.Heading = Custom and scheduled

CategoryName.Purchasing = Purchasing
CategoryName.Inventory = Inventory
CategoryName.Sales = Sales
CategoryName.Fulfillment = Fulfillment 
CategoryName.Production = Production
CategoryName.Accounting = Accounting
CategoryName.Rentals = Rentals
CategoryName.Miscellaneous = Miscellaneous

FilterLabel.AdjustedOut = Adjusted out
FilterLabel.AsOfDate = As of date
FilterLabel.AssignedTo = Assigned to
FilterLabel.BinNumberContains = Bin number contains
FilterLabel.Bills = Bills
FilterLabel.Category = Category
FilterLabel.CashPurchases = Cash purchases
FilterLabel.Channel = Channel
FilterLabel.ChannelNameContains = Channel name contains
FilterLabel.LotNumberContains = Lot number contains
FilterLabel.Check = Check
FilterLabel.Class = Class
FilterLabel.ClassNameContains = Class name contains
FilterLabel.CreditCardCharges = Credit card charges
FilterLabel.JobNameContains = Job name contains
FilterLabel.Customer = Customer
FilterLabel.CustomerNameContains = Customer name contains
FilterLabel.CustomerType = Customer type
FilterLabel.CustomerTypeNameContains = Customer type name contains
FilterLabel.DepartmentNameContains = Department name contains
FilterLabel.Department = Department
FilterLabel.DropShip = Drop ship
FilterLabel.DropShipPurchaseOrder = Drop ship purchase order
FilterLabel.Expired = Expired
FilterLabel.FromDate = From date
FilterLabel.InStock = In stock
FilterLabel.InputItemNameContains = Input item name contains
FilterLabel.ItemNameContains = Item name contains
FilterLabel.PriceTierNameContains = Price tier name contains
FilterLabel.AssemblyNameContains = Assembly name contains
FilterLabel.CustomerNameContains = Customer name contains
FilterLabel.ComponentNameContains = Component name contains
FilterLabel.ItemProduced = Item produced
FilterLabel.Location = Location
FilterLabel.LotNumberContains = Lot number contains
FilterLabel.LocationNameContains = Location name contains
FilterLabel.NotExpiredNotRecalled = Not expired, not recalled
FilterLabel.OrderType = Order type
FilterLabel.Outputs = Outputs
FilterLabel.OutputItemNameContains = Output item name contains
FilterLabel.PaymentType = Payment type
FilterLabel.PriceTier = Price tier
FilterLabel.Quantity = Quantity
FilterLabel.Recalled = Recalled
FilterLabel.SalesRep = Sales rep
FilterLabel.SerialNumberContains = Serial number contains
FilterLabel.Shipped = Shipped
FilterLabel.ShowAllOutputs = Show all outputs
FilterLabel.ShowWasteOnly = Show waste only
FilterLabel.ShowNonWasteOnly = Show non waste only
FilterLabel.ToDate = To date
FilterLabel.TransactionType = Transaction type
FilterLabel.Unassigned = Unassigned
FilterLabel.Used = Used
FilterLabel.Vendor = Vendor
FilterLabel.VendorNameContains = Vendor name contains

OptionLabel.AutoAddToReorderList = Auto-add to reorder list
OptionLabel.Customer = Customer
OptionLabel.Class = Class
OptionLabel.Channel = Channel
OptionLabel.Category = Category
OptionLabel.Component = Component
OptionLabel.Department = Department
OptionLabel.ExpandSubAssemblies = Expand sub-assemblies
OptionLabel.FromPaymentDate = From payment date
OptionLabel.GroupBy = Group by
OptionLabel.HideEmptyBins = Hide empty bins
OptionLabel.HideEmptyLots = Hide empty lots
OptionLabel.HideRowsWithNoPurchases = Hide rows with no purchases
OptionLabel.HideRowsWithNoTransactions = Hide rows with no transactions
OptionLabel.HideRowsWithAllZeros = Hide rows with all zeros
OptionLabel.HideRowsWithNoShipmentsOrInventory = Hide rows with no shipments or inventory
OptionLabel.HideRowsWithNoSales = Hide rows with no sales
OptionLabel.HideRowsWithNoSalesOrShipments = Hide rows with no sales or shipments
OptionLabel.HighlightReorders = Highlight reorders
OptionLabel.HighlightPastDueDates = Highlight past due dates
OptionLabel.IncludeArchivedItems = Include archived items
OptionLabel.IncludeArchivedAssemblies = Include archived assemblies
OptionLabel.IncludeArchivedCustomers = Include archived customers
OptionLabel.IncludeArchivedTransactions = Include archived transactions
OptionLabel.IncludeArchivedLots = Include archived lots
OptionLabel.IncludeArchivedJobs = Include archived jobs
OptionLabel.IncludeArchivedCategories = Include archived categories
OptionLabel.IncludeArchivedCustomers = Include archived customers
OptionLabel.IncludeArchivedVendors = Include archived vendors
OptionLabel.IncludeDeletedItems = Include deleted items
OptionLabel.IncludeDeletedSerials = Include deleted serials
OptionLabel.IncludeDeletedLots = Include deleted lots
OptionLabel.IncludeDeletedAssemblies = Include deleted assemblies
OptionLabel.IncludeDeletedCustomers = Include deleted customers
OptionLabel.IncludeDeletedVendors = Include deleted vendors
OptionLabel.IncludeDeletedJobs = Include deleted jobs
OptionLabel.IncludePOsInCalculation =  Include POs in calculation
OptionLabel.IncludeRMAsInCalculation = Include RMAs in calculation
OptionLabel.IncludeRentalsInCalculation = Include rentals in calculation
OptionLabel.IncludeWOsInCalculation = Include WOs in calculation
OptionLabel.Item = Item
OptionLabel.Location = Location
OptionLabel.NonZeroOnly = Non-zero only
OptionLabel.OpenClosed = Open / closed
OptionLabel.OverstockUnderstock = Overstock / understock
OptionLabel.OnlyShowFullyShippedOrders = Only show fully-shipped orders
OptionLabel.Output = Output
OptionLabel.ShowOnlyItemsThatHaveBeenPicked = Show only items that have been picked
OptionLabel.Parent = Parent
OptionLabel.SalesRep = Sales rep
OptionLabel.ShowOnlyIfInBin = Show only if in bin
OptionLabel.ShowSerials = Show serials
OptionLabel.ShowFromAndToDates =  Show "from" and "to" dates
OptionLabel.ShowLots = Show lots
OptionLabel.ShowBins = Show bins
OptionLabel.ReportValue =  Report value
OptionLabel.ShowAsOfDate = Show "as of" date
OptionLabel.Status = Status
OptionLabel.ToPaymentDate = To payment date
OptionLabel.TreatEmptyReorderPointsAsZero = Treat empty reorder points as zero
OptionLabel.Vendor = Vendor
OptionLabel.UseStandardCosts =  Use standard costs
OptionLabel.UseStandardSalePrices = Use standard sales prices
OptionLabel.UseAvailableQuantityInsteadOfOnHandQuantity = Use available qty instead of on hand qty
OptionLabel.ShowTransactionSummaryOnly = Show transaction summary only
OptionLabel.SubtractCustomerReturns = Subtract customer returns
OptionLabel.ShowOnlyIfOrderInvoicedOrInvoicePaid = Show only if order invoiced or invoice paid
OptionLabel.ShowOnlyOrdersThatCanShipInFull = Show only orders that can ship in full
OptionLabel.UseNetInsteadOfGrossBeta = Use net instead of gross (beta)  

oneYearMax = one year max

hoverHelp.CommentKeywordSearch = Keyword search in the comment field.
hoverHelp.SalesWithPoKeywordSearch = Keyword search in customer PO, comment, and customer message fields.
hoverHelp.SalesKeywordSearch = Keyword search in comment and customer message fields.
hoverHelp.PurchaseKeywordSearch = Keyword search in comment and vendor message fields.
hoverHelp.ShowTransactionSummaryOnly = Only transaction-level filters and columns will work if this option is enabled.
hoverHelp.UseNetInsteadOfGrossBeta = This feature is in an early-release state and might have more issues than normal. Use with caution and contact us if you run into any problems.
hoverHelp.RunThisReportNow = Run this report now, with the given email and/or FTP server
hoverHelp.ShowOnlyIfOrderInvoicedOrInvoicePaid = If the Order type filter is set for Sales orders, the report will reflect invoiced sales orders only. If the Order type filter is set for Invoices, the report will reflect only those invoices which have been paid.

categories = categories
earliest = earliest
From = From 
ItemFilterRequired = An item must be selected
KeywordSearch = Keyword search
latest = latest
LocationFilterRequired = A location must be selected
SalesRepFilterRequired = A sales rep must be selected
AssignedToFilterRequired = An assigned to user selection is required
OrderTypeFilterRequired = An order type must be selected
locations = locations
LotFilterRequired = A lot filter must be selected
to = to
salesReps = sales reps
ShowBothOverstockAndUnderStock = Show both overstock and understock
ShowDropShippedOnly = Drop-shipped
ShowNotDropShippedOnly = Not drop-shipped
ShowOverstockOnly = Show overstock only
ShowUnderstockOnly = Show understock only
ThisReportDoesNotHaveSelectableColumns = This report does not have selectable columns

Subheader.categories.singular = category
Subheader.categories.plural = categories
Subheader.locations.singular = location
Subheader.locations.plural = locations
Subheader.salesReps.singular = sales rep
Subheader.salesReps.plural = sales reps

withChannel = with channel
withDepartment = with department
withClass = with class
withPriceTier = with price tier
containing = containing
NoSelectionDefaultsToTotalsOnly = No selection defaults to totals only

placeholder.DefaultIsAll = Default is all {{type}}
placeholder.DefaultIsTotalsOnly = Default is totals only

ScheduledReportOptions.Frequency.Daily = Daily
ScheduledReportOptions.Frequency.Weekly = Weekly
ScheduledReportOptions.Frequency.Monthly = Monthly

ScheduledReportOptions.Days.Monday = Mon
ScheduledReportOptions.Days.Tuesday = Tue
ScheduledReportOptions.Days.Wednesday = Wed
ScheduledReportOptions.Days.Thursday = Thu
ScheduledReportOptions.Days.Friday = Fri
ScheduledReportOptions.Days.Saturday = Sat
ScheduledReportOptions.Days.Sunday = Sun

ScheduledReportOptions.Times.0 = Midnight
ScheduledReportOptions.Times.1 = 1:00 AM
ScheduledReportOptions.Times.2 = 2:00 AM
ScheduledReportOptions.Times.3 = 3:00 AM
ScheduledReportOptions.Times.4 = 4:00 AM
ScheduledReportOptions.Times.5 = 5:00 AM
ScheduledReportOptions.Times.6 = 6:00 AM
ScheduledReportOptions.Times.7 = 7:00 AM
ScheduledReportOptions.Times.8 = 8:00 AM
ScheduledReportOptions.Times.9 = 9:00 AM
ScheduledReportOptions.Times.10 = 10:00 AM
ScheduledReportOptions.Times.11 = 11:00 AM
ScheduledReportOptions.Times.12 = Noon
ScheduledReportOptions.Times.13 = 1:00 PM
ScheduledReportOptions.Times.14 = 2:00 PM
ScheduledReportOptions.Times.15 = 3:00 PM
ScheduledReportOptions.Times.16 = 4:00 PM
ScheduledReportOptions.Times.17 = 5:00 PM
ScheduledReportOptions.Times.18 = 6:00 PM
ScheduledReportOptions.Times.19 = 7:00 PM
ScheduledReportOptions.Times.20 = 8:00 PM
ScheduledReportOptions.Times.21 = 9:00 PM
ScheduledReportOptions.Times.22 = 10:00 PM
ScheduledReportOptions.Times.23 = 11:00 PM

explanation.BackorderReport = Lists data on backordered (unshipped) sales orders and sales receipts
explanation.BinContents = Lists bin contents by location and bin number, along with the quantity on hand for each bin item
explanation.DeletedItems = Displays a list of deleted Items and allows restore of such items
explanation.CommissionReport = Shows commission data filtered by the sales representative, item name, customer, and order type
explanation.ExpandedBOM = Provides details on an assembly item, including each component, its vendor, the quantity on hand, the quantity used in a build, the cost of each component, and the line total
explanation.FulfillmentEfficiency = Provides information on the turnaround time in fulfilling customer orders from the time a sales order or sales receipt is placed until such sale is shipped
explanation.InventoryAging = Provides a list of items on hand and how long they have been in inventory, along with the transaction that brought them into inventory
explanation.InventoryStockStatus = Shows a list of items and their on-hand quantities
explanation.InventorySummary = Shows a list of items to include the on hand, on transactions, and available for sale quantities
explanation.InventoryTurnover = Shows the number of times inventory is sold or consumed in a given time period
explanation.InventoryValuation = Shows a list of items and their on-hand quantities, along with the value
explanation.ItemAnalysis = Shows a list of items that have sold or shipped in the report period along with cost and sales price average; highlights indicate areas where standard costs/prices used
explanation.ItemMovement = Provides details about items’ movements on transactions: the quantity received, returned to vendors, shipped, adjusted, etc., as well as the total quantity in and out
explanation.ItemsInBins = Compiles data on bin-tracked items that includes item location, bin number, and quantity on hand
explanation.LotHistory = Shows the transaction history of lot-tracked items
explanation.LotStockStatus = Gives data on the current status of a lot-tracked item
explanation.LotsInBins = Provides data on a lot-tracked item stored in bins
explanation.LotTraceability = Allows you to enter a lot and trace either where the lot came from or where the lot went
explanation.MasterPurchaseReport = Provides line detail information regarding purchase orders, item receipts, and returns to vendors
explanation.MasterSalesReport = Provides line level detail of sales transactions in the report period
explanation.OpenPurchaseOrderDetail = Provides data on purchase orders with items that have yet to be received
explanation.OpenRentalDetail = Shows line level detail of rental transactions that have yet to be returned
explanation.OpenSalesOrderDetail = Shows open sales order transactions with unshipped items
explanation.OpenSalesReceiptDetail = Shows open sales receipt transactions with unshipped items
explanation.OpenWorkOrderDetail = Shows status of open work orders
explanation.OverstockUnderstockReport = Gives a breakdown of inventory for a specified item; the report includes the item’s reorder and maximum stock level, as well as the total quantity
explanation.PhysicalInventoryWorksheet = Creates a worksheet that includes the system count of one or more items and a column for you to enter the actual count of each item listed
explanation.PriceBook = Provides pricing information about items, the price tier and customer to whom an item is sold, along with the quantity and sales price
explanation.ProductionReport = Provides information on build and process transactions, the outputs, and the output quantity
explanation.ProfitLossByCustomer = Provides a list of customers and reflects sales revenue from sales in the report period along with COGS from shipments in the report period
explanation.ProfitLossByItem = Provides a list of items and reflects sales revenue from sales in the report period along with COGS from shipments in the report period
explanation.ProfitLossByJob = Provides a list of Jobs and reflects sales revenue from sales in the report period along with COGS from shipments in the report period
explanation.PurchaseVariances = Shows the difference between standard purchase price and actual purchasing costs
explanation.PurchasesByCategorySummary = Provides a list of categories along with quantities purchased of each category in the report period
explanation.PurchasesByClassSummary = Provides a list of classes along with quantities purchased within each class in the report period
explanation.PurchasesByCustomerSummary = Provides a list of customers along with quantities purchased for each customer in the report period; customer must have been listed on the purchase transaction
explanation.PurchasesByDepartmentSummary = Provides a list of departments along with quantities purchased in the report period
explanation.PurchasesByItemSummary = Provides a list of items along with the quantities purchased in the report period
explanation.PurchasesByLocationSummary = Provides a list of locations along with quantities purchased for each location
explanation.PurchasesByVendorSummary = Provides a list of vendors along with totals purchased from each vendor
explanation.ReadyToInvoice = Shows lines of open sales orders that have shipped but not yet been invoiced
explanation.ReadyToPickShip = Shows a list of sales orders and sales receipts that are ready to be picked and/or shipped
explanation.RentalCalendar = Shows the due dates for items on open rental transactions
explanation.ReorderReport = Provides a list of items whose available quantity is equal to or less than the item reorder point
explanation.SalesByCategorySummary = Provides a list of Categories and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByChannelSummary = Provides a list of Channels and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByClassSummary = Provides a list of Classes and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByCustomerSummary = Provides a list of Customers and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByCustomerTypeSummary = Provides a list of Customer Types and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByDepartmentSummary = Provides a list of Departments and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByItemSummary = Recaps by item the units shipped, revenue, COGS, and profit, as well as the percentages in each of these categories
explanation.SalesByLocationSummary = Provides a list of Items and reflects sales revenue from sales along with COGS from shipments for sales that shipped in the report period
explanation.SalesByVendorSummary = Provides a list of Vendors and reflects sales revenue from sales of items assigned vendor as preferred along with COGS from shipments for sales that shipped in the report period
explanation.SellThroughReport = Shows the percentage of a product that is sold to customers after being received from vendors for a certain date range
explanation.SerialHistory = Shows the transaction history of serial-tracked items
explanation.SerialsInBins = Compiles data on serial-tracked items that includes the serial number, item name, location, and bin number
explanation.ShippingReport = Shows completed shipments by transaction, ship date, customer, item and quantity shipped of an inventory item
explanation.TransactionsAssigned = Provides a list of transactions with the name of the individuals to whom they have been assigned
explanation.VendorEfficiency = Provides information on the turnaround time used by a vendor from the time a purchase order is placed until it is received
explanation.WhereToBuy = Compiles data from the Vendor-Item Catalog so that you can see which of your vendors sell an item, each vendor’s price, and the quantity you need to order
explanation.WhereUsed = Shows a list of assemblies and kits that an item is included in such bill of materials (BOM)
explanation.WorkInProgress = Lists builds and processes that are in a work in progress workcenter
explanation.ReconcileItemReceipts = Compares SOS Inventory transactions in the selected period to the associated transactions in QuickBooks Online, highlighting any differences
explanation.ReconcileJournalEntries = Compares SOS Inventory transactions in the selected period to the associated transactions in QuickBooks Online, highlighting any differences
explanation.ReconcileVendorCredits = Compares SOS Inventory transactions in the selected period to the associated transactions in QuickBooks Online, highlighting any differences

[sosPayments]

01 = SOS Pay
02 = Why add payment processing to SOS?
03 = Receive payments in SOS against invoices, sales orders, and sales receipts.
04 = Sync payments with QuickBooks.
05 = Process credit card and ACH payments in SOS at low rates.
06 = Let customers pay invoices online via a convenient payment link.
07 = Click the button below to get started.
08 = 2.8%
09 = + 30 cents per successful charge
10 = Simple, fixed, straightforward pricing at a low rate.
11 = No monthly fees. No setup fees. No hidden fees.
12 = Easy to budget and plan.
13 = Streamlined onboarding process.
14 = Request SOS Pay registration information
15 = Contact us
16 = Thanks for your interest in using SOS Inventory's payments solution. Please complete and submit the form below, and we'll be in touch soon with information on completing your registration.
17 = Contact name
18 = Contact email
19 = Contact phone
20 = Company name
21 = Brief description of the business
22 = We've got your information and will be in touch soon!
23 = Something went wrong. Please call us at 817-422-5909.

[import]
DataImport = Data import
ImportingYourData = We are importing your data. You will receive a notification when complete.
Import = Import
Preview = Preview
moreRows = more rows


[dataUtilities]
RetrieveFromQuickBooks = Retrieve from QuickBooks
Retrieve = Retrieve
Retrieve.hoverHelp = Click the button to retrieve an update from QuickBooks of all the records of your selected type. Depending on the number of records in your QuickBooks account, this can take anywhere from a few seconds to a few hours. You can continue to work on other things while the records are being retrieved."

header = Data utilities
ClearItemCache = Clear item cache
BeginUpdate = Begin update
BeginUpdate.hoverHelp = Click the button to force an update to the cost values on your historical transactions (builds, shipments, etc.). Depending on the number of transactions in your database, this can take anywhere from a few seconds to a few hours. If you leave the date blank, it will recalculate all transactions. This could be helpful, for example, if you made a settings change and want to recalculate all data according to the new setting.
ClearItemCache.hoverHelp = Click the button to clear the cache for all items. In most cases, it is better to let the system manage the cache automatically. However, clearing it manually can be useful in certain situations. The downside to this action is that certain reports and data retrieval will be slower temporarily while the system rebuilds the cache.
ClearCacheUpdateStarted = Update started. You will receive a system notification when the update is complete.
UpdateHistoricalCosts = Update historical costs
StartingOn = Starting on
UpdateHistoricalCostsStarted = Update started. This will take a while. You will receive a system notification when the update is complete.

[notes]
BlueMeansNotSentToQbo = Blue means that the {{type}} could not be sent to QuickBooks.
GreenMeansNoMatchingInQbo = Green means that SOS could not find the {{type}} in QuickBooks when trying to reconcile.
journalEntry = journal entry
matchingTranasction = matching transaction
RedMeansCostDoesNotMatch = Red means that the cost in SOS does not match the cost in QuickBooks.
ReconcileVendorCredits = This report helps you to determine differences between return to vendor transactions (affecting SOS Inventory value) and corresponding vendor credit transactions in QuickBooks (usually affecting the asset account). There might be times when the credit that the vendor gives you is not the same as the inventory value of the item. In this case, you will need to make an adjustment (either in QuickBooks or in SOS) for your inventory values to reconcile. Please contact support at support@sosinventory.com or 817-422-5909 if you have any questions.
WillBeAvailableForPeriodOfTime = The old commission report will be available for period of time while our customers transition to this one.
ShownOnFirstLine = Per-transaction commissions and transaction-level discounts are shown on the first line of a transaction.
TaxCodesMustBeEditedInQBO = Tax codes must be created and edited in QuickBooks. They cannot be edited in SOS Inventory.
vendorCredit = vendor credit
YellowMeansNoMatchingInSOS = Yellow means that no {{type}} was created in SOS.
onSoSr = Note: If the item in the report is a component of the item on the transaction, the above list will reflect the kit/assembly item on the transaction, but the quantity will reflect the corresponding quantity of the component. This behavior is by design.
onWo = Note: The item on the above report reflects the item on the work order to be built but reflects the quantities of the components to be used to build the item on the work order.
onRental = Note: The quantity column above shows the quantity of the item ordered. If the item in the report is a component of the item ordered, the quantities might not match the total in the "On Rental" column of the Item List. This behavior is by design.

[expiredDisabled]
SubscriptionExpired = Subscription expired
Admin.ExpiredMessage.1 = Your company's subscription to SOS Inventory has expired. Please provide updated
Admin.ExpiredMessage.2 = payment information
Admin.ExpiredMessage.3 = to access your account.
NonAdmin.ExpiredMessage = Your company's subscription to SOS Inventory has expired. Please have an admin update the payment information to access the account.
SubscriptionDisabled = Account disabled
DisabledMessage = Your account is currently disabled for administrative reasons.
ContactSupport.1 = You may contact support at
ContactSupport.2 = if you have issues reactivating your account.

[home]
live.title = Welcome to SOS Inventory Version 9!
live.header = Home

live.p1 = We're excited for you to experience our latest release, packed with enhancements designed to streamline your workflow and improve productivity:

live.bullet.1 = A sleek, modernized interface for easier navigation.
live.bullet.2 = Fully customizable list views, tailored to how you work.
live.bullet.3 = Enhanced in-line data entry directly within transactions: quickly add new customers, vendors, and items.
live.bullet.4 = Powerful, expanded global search to find what you need faster.
live.bullet.5 = Convenient in-transaction attachments to keep documents organized.
live.bullet.6 = Intuitive transaction handling for serial and lot-tracked items.
live.bullet.7 = Centralized, all-in-one configuration center.
live.bullet.8 = Seamless sync with QuickBooks Payments.
live.bullet.9 = Redesigned reports and exports for clearer insights.

live.p2.1 = Have questions or want to learn more? Visit our 
live.p2.2 = Version 9 Help Center
live.p2.3 = for detailed guides and resources.
live.p3.1 = If you need to return to version 8, you can do so at
live.p5 = We're committed to continuously improving your experience. Your feedback is valuable and appreciated!

trial.1 = There are
trial.2 = remaining in your trial period. 
trial.3 = Click here to subscribe.

help.title = How Can We Help?

help.p1.1 = Did you know that in addition to email and phone support, we offer demos, training, and implementation assistance? For more information, email our support team at
help.p1.2 = , or send us a message via our
help.p1.3 = Contact
help.p1.4 = page.

help.p2.1 = As always, please email us at
help.p2.2 = if you have any comments, questions, or suggestions.

[whatsNew]
WhatsNew = What's new

9.0.header = Version 9.0 - July 31, 2025
9.0.1 = Modern, streamlined interface
9.0.2 = Customizable list views with added functionality
9.0.3 = Enhanced in-line data entry on transactions for new customers, vendors, and items
9.0.4 = Expanded global search
9.0.5 = In-transaction attachments
9.0.6 = More intuitive serial and lot item transaction use
9.0.7 = All-in-one configuration center
9.0.8 = QuickBooks Payments sync
9.0.9 = Redesigned reports and exports
9.0.10 = Numerous performance improvements, miscellaneous bug fixes, and other enhancements.

8.16.header = Version 8.16 - Sept 17, 2023
8.16.1 = Added Produce All option to the Work order quick view.
8.16.2 = Performance improvements.
8.16.3 = Miscellaneous bug fixes and enhancements.

8.15.header = Version 8.15 - May 1, 2022
8.15.1 = SOS Pay improvements
8.15.2 = Support for tracking urls for APC, DPD, Parcelforce, TNT, and UK Mail carriers
8.15.3 = Performance improvements.
8.15.4 = Miscellaneous bug fixes and enhancements.

8.14.header = Version 8.14 - April 3, 2022
8.14.1 = Performance improvements.
8.14.2 = Miscellaneous bug fixes and enhancements.

8.13.header = Version 8.13 - March 6, 2022
8.13.1 = New payment date filter on commissions report (with payments enabled).
8.13.2 = Other reporting enhancements.
8.13.3 = Performance improvements, including improvements to synchronization speed with QBO.
8.13.4 = Miscellaneous bug fixes and enhancements.

8.12.header = Version 8.12 - February 6, 2022
8.12.1 = Reporting enhancements
8.12.2 = Performance improvements.
8.12.3 = Miscellaneous bug fixes and enhancements.

8.11.header = Version 8.11 - December 26, 2021
8.11.1 = Performance improvements.
8.11.2 = Miscellaneous bug fixes and enhancements.

8.10.header = Version 8.10 - September 26, 2021
8.10.1 = Customers can now pay invoices online via credit card or ACH (with payments enabled).
8.10.2 = Performance improvements.
8.10.3 = Miscellaneous bug fixes and enhancements.

8.9.header = Version 8.9 - May 31, 2021
8.9.1 = Enabled the new payments feature of SOS for beta testing.
8.9.2 = Performance improvements.
8.9.3 = Miscellaneous bug fixes and enhancements.

[contactUs]
Success = We received your message and will get back to you shortly.
Confirmation = Your request was succesfully sent, and support will be reaching out to you.
header = Contact us
SubmitAnotherTicket = Submit another support ticket
WeWillReplyTo = We will reply to 

1 = For fastest results, we recommend that you contact our Support team via email. This allows us to track and assign your case to the appropriate person, as well as look up your account (if necessary) to help answer your question.
2.1 = Email us directly at
2.2 = or complete the form below. We will respond to you via email as quickly as possible.
3 = 'Please describe your problem in detail and refer to a specific transaction when appropriate. For example, "Please look at PO #123. I need to edit it, but the system says it is closed."'

[dashboard]
pendingEstimates = Pending estimates
openSos = Open lines on sales orders
openSrs = Open sales receipts
readyToShip = Lines ready to ship
readyToInvoice = Lines ready to invoice
openPos = Open purchase orders
openWos = Open work orders
openRmas = Open RMAs
lastSync = Date of last sync
txnsToSend = Transactions to send
showTxnsSent = Transactions sent
showRentalsPastDue = Rentals past due
Never = Never

RefreshDashboard = Refresh dashboard
Settings = Settings
DashboardSettings = Dashboard settings

show.pendingEstimates = Pending estimates
show.openSos = Open sales orders
show.openSrs = Open sales receipts
show.readyToShip = Ready to ship
show.readyToInvoice = Ready to invoice
show.openPos = Open purchase orders
show.openWos = Open work orders
show.openRmas = Open RMAs
show.lastSync = Last sync date
show.txnsToSend = "# of transactions to send to QuickBooks"
show.showTxnsSent = "# of transactions sent to QuickBooks"
show.showRentalsPastDue = Past due rentals

[about]
version = Version
apiVersion = API version
masterServiceAgreement = Master Service Agreement
privacyPolicy = Privacy policy

[syncitem]
DeleteConfirm = Delete sync item?
MoveToEnd = Move to bottom
MoveToEndSuccess = Moved
MoveToEndFailure = Could not move the sync item
GoTo = Go to

labelAction = Action
labelObject = Object
labelType = Type

[calendar]

Heading = Calendar
monday = Monday
tuesday = Tuesday
wednesday = Wednesday
thursday = Thursday
friday = Friday
saturday = Saturday
sunday = Sunday

january = January
february = February
march = March
april = April
may = May
june = June
july = July
august = August
september = September
october = October
november = November
december = December

thisMonth = Return to current month

settingsButton = Settings
settingsHeader = Calendar settings

entryLabel.task = Tasks
entryLabel.invoice = Invoices
entryLabel.rma = RMAs
entryLabel.pickticket = Pick tickets
entryLabel.workorder = Work orders
entryLabel.salesorder = Sales orders
entryLabel.lot = Lots
entryLabel.purchaseorder = Purchase orders
entryLabel.salesreceipt = Sales receipts
entryLabel.shipment = Shipments
entryLabel.rental = Rentals

suffix.toBeCompleted = to be completed
suffix.expiring = expiring
suffix.expected = expected
suffix.withAnItemDue = with an item due
suffix.due = due
suffix.toBePicked = to be picked
suffix.toBeShipped = to be shipped

Error.UnableToSaveSettings = We were unable to save your calendar settings. Please try again."

[configuration]

searchTerm.Abbreviation = Abbreviation
searchTerm.Address = Address
searchTerm.AssetAccount = Asset account
searchTerm.AttachedTo = Attached to
searchTerm.BinTracking = Bin tracking
searchTerm.CarrierCode = Carrier code
searchTerm.Commission = Commission
searchTerm.DateDiscountPercent = Date discount percent
searchTerm.DayOfMonthDue = Day of month due
searchTerm.DiscountDays = Discount days
searchTerm.DiscountPercent = Discount percent
searchTerm.DiscountDayOfMonth = Discount day of month
searchTerm.DueDays = Due days
searchTerm.Duration = Duration
searchTerm.DueNextMonthDays = Due next month days
searchTerm.FirstName = First name
searchTerm.Inputs = Inputs
searchTerm.LastName = Last name
searchTerm.LeadTime = Lead time
searchTerm.NonNettable = Non nettable
searchTerm.Outputs = Outputs
searchTerm.RestrictCustomers = Restrict customers
searchTerm.SalesTaxRate = Sales tax rate
searchTerm.SequenceNumber = Sequence number
searchTerm.ShipStationCarrier = ShipStation carrier
searchTerm.ShipStationService = ShipStation service
searchTerm.ShowOn = Show on
searchTerm.SortOrder = Sort order
searchTerm.VendorPartNumber = Vendor part number
searchTerm.UserEmail = User email

Configuration = Configuration

[aopRule]
action.AssignToAUser = "Assign to a User"
action.CreateANewTransaction = "Create a New Transaction"
action.NotifyAUser = "Notify a User"
action.SendAnEmail = "Send an Email"
action.SetThePriority = "Set the Priority"
action.MoveToStage =  "Move to Stage"

BlankToSendFormDefault = Leave this value blank to send to the form default.
FormAction = Please select a form action.

[settings]

UnableToUpdateSettings = Unable to update settings
UnableToUpdatePassword = Unable to update password
ChangePassword = Change password
OldPassword = Old password
NewPassword = New password
ConfirmNewPassword = Confirm new password

list.label = Lists

UserSettings.label = User settings
company.label = Company
general.label = General
accounting.label = Accounting
logo.label = Logo
nameAndAddress.label = Name and address
inventory.label = Inventory
accounts.label = Accounts
transactions.label = Transactions
purchasing.label = Purchasing
fulfillment.label = Fulfillment
payments.label = Payments
barcode.label = Barcode
connections.label = Connections
production.label = Production
quickbooks.label = QuickBooks
shipstation.label = ShipStation
ups.label = UPS
cart.label = Carts
ftp.label = FTP
api.label = API
customerPortal.label = Customer portal
users.label = Users

nextNumberHelperText = Enter an integer greater than zero

valuationMethod.Average = Weighted average
valuationMethod.FIFO = FIFO
valuationMethod.LIFO = LIFO

itemReceiptSyncOptions.None = None
itemReceiptSyncOptions.Bill = Bill
itemReceiptSyncOptions.Cash = Cash
itemReceiptSyncOptions.Check = Check
itemReceiptSyncOptions.CreditCard = Credit card

transactionNumbering.explanation = If desired, you may enter a prefix that will be automatically prefixed to all {{transactionType}} transactions. If you want to (re)set the next {{transactionType}} number, you can do that as well. Both fields are optional. You can always enter a transaction number manually when creating or editing a transaction.

inventory.general.allowNegativeInventory.label = Allow negative inventory
inventory.general.allowNegativeInventory.explanation = If this option is checked, SOS Inventory will not warn you when shipping, using, or adjusting items that would cause your inventory to go negative.
inventory.general.allowNegativeInBins.label = Allow negative inventory in bins
inventory.general.allowNegativeInBins.explanation = If this option is checked, SOS Inventory will allow you to enter a transaction that would cause the inventory in a bin to go negative.
inventory.general.defaultItemIsTaxable.label = New items taxable
inventory.general.defaultItemIsTaxable.explanation = Check this option to set new items as taxable by default.
inventory.general.defaultItemSyncWithQBO.label = Sync new items
inventory.general.defaultItemSyncWithQBO.explanation = Check this option to sync new items with QuickBooks by default.
inventory.general.calculateReorderPoints.label = Calculate reorder points
inventory.general.calculateReorderPoints.explanation = Check this option to have SOS Inventory calculate reorder points automatically, on a weekly basis. The calculation makes an estimate based on historical data. Enabling this setting will override existing reorder points. You may wish to export your item data prior to enabling this setting, if you do not want to lose existing reorder points.
inventory.general.includeCategoryPrefix.label = Include category prefix on item names (formerly "Find items by short name")
inventory.general.includeCategoryPrefix.explanation = Check this box to include the category assigned to an item as a prefix to the item name on transactions, imports, exports, and reports.
inventory.general.searchAnyPartOfItem.label = Search any part of item name
inventory.general.searchAnyPartOfItem.explanation = Check this option to search for an item by any part of its name, instead of only the beginning of the name.
inventory.general.searchItemDescription.label = Search item description
inventory.general.searchItemDescription.explanation = Check this option to search for items by description, in addition to name. Enabling this can slow search results if you have a large number of items.
inventory.general.inventoryMethod.label = Valuation method
inventory.general.inventoryMethod.explanation = Select the method to be used for calculating the value of your inventory on reports, as well as item value as inventory is depleted (e.g., build input value, COGS on shipments, etc.). Any change in the valuation method will not affect transactions you created before making the switch to the new method.  However, if you resave historical transactions, this will cause the new valuation method to be used on that transaction and ALL transactions forward for the items on the saved transaction. If you are unsure about this change, contact a qualified accountant.
inventory.general.valueSerialsBySpecificId.label = Value serialized inventory items individually
inventory.general.valueSerialsBySpecificId.explanation = When this setting is enabled, each serialized unit is valued at its original cost, tied to its serial number. For example, if a Widget with serial number 123 is received at a cost of $10.00, that unit's stored cost will be set to $10.00. The system will not apply LIFO, FIFO, or weighted-average calculations to serialized items while this option is on. However, the value of a serial tracked item can be modified by process transactions where the same serial item is used as both an input and output.
inventory.general.useTransactionsForSerialQOH.label = Count serials by unit
inventory.general.useTransactionsForSerialQOH.explanation = Check this box to count serialized items by the number of serialized units, regardless of the transaction totals. This is an advanced setting and should not normally be changed. If you aren't sure, leave the default setting.
inventory.general.overrideFIFObyLocation.label = Always use average costs for cost by location
inventory.general.overrideFIFObyLocation.explanation = Check this box to calculate the cost basis at a specific location using average costs instead of FIFO or LIFO, even if you use FIFO or LIFO otherwise. This can be helpful in producing reports that are more meaningful, even though not strictly FIFO or LIFO.
inventory.general.dontShowQuantityWhenEditing.label = Suppress loading of on-hand quantities on builds, process transactions, pick tickets and shipments
inventory.general.dontShowQuantityWhenEditing.explanation = For customers creating long builds, process transactions, pick tickets or shipments, calculating item quantities for each item may slow input. Enable this option to remove that column.
inventory.general.pictureSize.label = Picture size (width x height)
inventory.general.pictureSize.explanation = Enter the pixel dimensions for inventory item images that will appear on the item page.
inventory.general.unitsOfMeasureEnabled.label = Use units of measure
inventory.general.unitsOfMeasureEnabled.explanation = Check this box to track multiple units of measure for your items.
inventory.general.rentalInventoryEnabled.label = Rental inventory
inventory.general.rentalInventoryEnabled.explanation = Check this box to enable rental inventory.
inventory.general.trackWorkersOnLaborItems.label = Track workers
inventory.general.trackWorkersOnLaborItems.explanation = Check this box to track individual workers when entering labor items on builds or process transactions.
inventory.general.serialLotNumbering.label = Serial/lot numbering
inventory.general.serialLotNumbering.explanation = ""
inventory.general.serialLotNumbering.explanation.1 = Use these settings to control how serial and lot numbers are created on transactions. You can enter numbers manually on item receipt and manufacturing transactions, or have the system assign them automatically.
inventory.general.serialLotNumbering.explanation.2 = If you choose automatic, choose a length, between 8 and 32 digits, for the numbers.
inventory.general.serialLotNumbering.explanation.3 = Numbers can be sequentially or randomly generated.
inventory.general.serialLotNumbering.explanation.4 = For both sequential and random serial and lot numbers, you can specify a prefix to be used for each serial or lot number.
inventory.general.serialLotNumbering.explanation.5 = For sequential numbering, you can specify the next number to be generated.
inventory.general.serialLotNumbering.autoLength = Serial/lot number length
inventory.general.serialLotNumbering.autoLength.helperText = Enter an integer between 8 and 32
inventory.general.serialLotNumbering.nextNumber.helperText = Enter an integer greater than zero
inventory.general.serialLotNumbering.prefix = Prefix
inventory.general.serialLotNumbering.nextNumber = Next number
inventory.general.hideItemName.label = Hide item name
inventory.general.hideItemName.explanation = Check this box to hide the item name on purchase orders, sales orders, and packing slips. This is often useful in drop shipping.

company.general.defaultTimeZone.label = Company time zone
company.general.defaultTimeZone.explanation = This time zone will be used when referencing dates for reports, automatically created transactions, and other places in the system where a company-defined time zone is required. If a user's time zone is not set, this company time zone will be used as the default for times throughout the system.
company.general.defaultDateFormat.label = Automated date format
company.general.defaultDateFormat.explanation = This date format will be used for transactions that are generated by SOS Inventory automatically. If a user is logged in, the user date format setting will override this setting.
company.general.starSettings.label = Star settings
company.general.starSettings.explanation = Controls the color(s) of stars that users can select on list pages.
company.general.numLinesToAdd.label = Default lines
company.general.numLinesToAdd.explanation = The number of line items displayed on new forms, as well as the number added when the green plus (+) icon is selected to add additional lines. The smallest possible value is 3 and the largest is 20.
company.general.defaultReportFormat.label = Default report format
company.general.defaultReportFormat.explanation = The default file format to be used for downloaded and scheduled reports.
company.general.sendEmailFromCustomerDomain.label = Send emails from customer domain
company.general.sendEmailFromCustomerDomain.explanation = SOS Inventory normally sends emails FROM an sosinventory.com address with the REPLY_TO address set to the defined sending email addresses. This is done to improve email deliverability to recipients. Enabling this setting will cause emails to be sent FROM the defined sending email addresses, increasing the risk of lower email deliverability.
company.general.inactivityTimeoutMinutes.label = Inactivity timeout
company.general.inactivityTimeoutMinutes.explanation = If this option is switched to On, it allows you to choose when to log a user out of SOS Inventory for inactivity. Use the slider to set the cutoff time.
company.general.paymentReceiptCC.label = Additional recipient for payment receipts 
company.general.paymentReceiptCC.explanation = If you would like someone other than the person who signed up for SOS Inventory Software to get receipts when payments are made for your subscription, enter their email address here.
company.general.transactionEditMode.label = Transaction edit mode
company.general.transactionEditMode.explanation = This setting controls how line items appear when viewing saved transactions. "Row by row" requires clicking each line's edit button before it becomes editable, which improves performance when viewing transactions with many line items. "All" displays all lines as editable by default, similar to new transactions.

company.general.defaultReportFormat.xlsx = Excel 2007+ (.xlsx)
company.general.defaultReportFormat.xls = Excel 1997-2003 (.xls)
company.general.defaultReportFormat.csv = CSV (.csv)

company.general.transactionEditMode.rowByRow = Row by row
company.general.transactionEditMode.all = All

company.general.starSettings.redyellowgreen = Red, yellow, green
company.general.starSettings.yellow = Yellow

company.general.inactivityTimeoutMinutes.5 = 5 minutes
company.general.inactivityTimeoutMinutes.15 = 15 minutes
company.general.inactivityTimeoutMinutes.30 = 30 minutes
company.general.inactivityTimeoutMinutes.60 = 1 hour
company.general.inactivityTimeoutMinutes.480 = 8 hours

company.accounting.neverConnectQBO.label = Never connect
company.accounting.neverConnectQBO.explanation = Check this box if you don't ever plan to connect to QuickBooks Online. This setting hides a number of options to simplify the user experience when not connected to QuickBooks. You can change this setting at any time.
company.accounting.multiCurrencyEnabled.label = Multicurrency
company.accounting.multiCurrencyEnabled.explanation = Check this box to enable the multicurrency capabilities of SOS Inventory.
company.accounting.homeCurrency.label = Home currency
company.accounting.homeCurrency.explanation = All transactions are stored in the system in your home currency by default. You can override this on individual transactions if the above-mentioned Multicurrency setting is enabled.
company.accounting.closingDate.label = Closing date
company.accounting.closingDate.explanation = If a date is specified, transactions on or prior to that date cannot be changed. Because any changes made in QuickBooks Online will override this setting, we recommend that the closing date in SOS matches the closing date in QuickBooks.

company.nameAndAddress.companyName.label = Company name
company.nameAndAddress.companyName.explanation = Your company name. If your company is connected to QuickBooks Online, your company name will be retrieved from QuickBooks automatically.
company.nameAndAddress.legalAddress.label = Company address
company.nameAndAddress.legalAddress.explanation = ""
company.nameAndAddress.companyHeader.label = Company header
company.nameAndAddress.companyHeader.explanation = The header will appear on transactions such as purchase orders, sales orders, and packing slips.

company.logo.logoWidth.label = Logo width
company.logo.logoWidth.explanation = Enter the width of your logo in pixels. A common width is 144, which is about 2 inches. Every computer and every printer are different, so you may need try different values here to size it exactly as you want. Leave this field blank to use the logo's original size.
company.logo.logoHeight.label = Logo height
company.logo.logoHeight.explanation = Enter the height of your logo in pixels. A common width is 144, which is about 2 inches. Every computer and every printer are different, so you may need try different values here to size it exactly as you want. Leave this field blank to use the logo's original size.
company.logo.logoImageFile.label = Logo file
company.logo.logoImageFile.explanation = The logo appearing on your forms. The uploaded file should be less than 2 MB in size. The image is scaled to the size you set in the Logo width and Logo height fields below. JPEG (*.jpg or *.jpeg), PNG (*.png), and GIF (*.gif) files are accepted.

company.logo.AddLogo = Add logo
company.logo.ChangeLogo = Change logo
company.logo.ClearLogo = Clear logo
company.logo.DownloadLogo = Download logo

inventory.accounts.defaultIncomeAccount.label = "Default income account"
inventory.accounts.defaultAssetAccount.label = "Default asset account"
inventory.accounts.defaultCOGSAccount.label = "Default cost of goods account"
inventory.accounts.defaultAdjustmentAccount.label = "Default adjustment account"
inventory.accounts.defaultCheckAccount.label = "Default checking account"
inventory.accounts.defaultCreditCardAccount.label = "Default credit card account"
inventory.accounts.defaultCashPurchaseAccount.label = "Default cash account"

inventory.transactions.adjustmentNumber.label = Adjustment numbering
inventory.transactions.adjustmentNumber.explanation = ""
inventory.transactions.transferNumber.label = Transfer numbering
inventory.transactions.transferNumber.explanation = ""

inventory.accounts.defaultIncomeAccount.label = "Default income account"
inventory.accounts.defaultIncomeAccount.explanation = "Default income account for new items."
inventory.accounts.defaultAssetAccount.label = "Default asset account"
inventory.accounts.defaultAssetAccount.explanation = "Default inventory asset account for new items."
inventory.accounts.defaultCOGSAccount.label = "Default cost of goods account"
inventory.accounts.defaultCOGSAccount.explanation = "Default cost of goods sold account for new items. "
inventory.accounts.defaultAdjustmentAccount.label = "Default adjustment account"
inventory.accounts.defaultAdjustmentAccount.explanation = "Default account to use for tracking inventory adjustments. Typically, this would be something like Breakage, Spoilage, or Adjustments."
inventory.accounts.defaultCheckAccount.label = "Default checking account"
inventory.accounts.defaultCheckAccount.explanation = "Default account for new checks issued while receiving items. "
inventory.accounts.defaultCreditCardAccount.label = "Default credit card account"
inventory.accounts.defaultCreditCardAccount.explanation = "Default account for new credit card charges made while receiving items."
inventory.accounts.defaultCashPurchaseAccount.label = "Default cash account"
inventory.accounts.defaultCashPurchaseAccount.explanation = "Default account for new cash purchases made while receiving items."

inventory.barcode.settings.label = Barcode settings
inventory.barcode.settings.explanation = "Choose a format and enter the dimensions for printing, in inches."
inventory.barcode.settings.sampleScaledToFit = (MAY BE SCALED TO FIT)

fulfillment.shipments.shipmentNumber.label = Shipment numbering
fulfillment.shipments.shipmentNumber.explanation = ""
fulfillment.shipments.autoBuildShipment.label = Auto-build assemblies 
fulfillment.shipments.autoBuildShipment.explanation = Check this option to build assemblies automatically when creating a shipment. This feature builds only top-level assemblies, not all levels of a multi-level assembly. 
fulfillment.shipments.packingSlipText.label = Packing slip title 
fulfillment.shipments.packingSlipText.explanation = Change this value if a different title (for example, Packing List) is desired when printing or emailing shipments. The title should not be more than 50 characters. 
fulfillment.shipments.replyEmailPS.label = Packing slip Reply-To
fulfillment.shipments.replyEmailPS.explanation = The email address where you will receive replies to your packing slip emails.
fulfillment.shipments.packingSlipEmail.label = Packing slip message 
fulfillment.shipments.packingSlipEmail.explanation.1 = The body of the email message to be sent with your packing slips. Do not use HTML. 
fulfillment.shipments.packingSlipEmail.explanation.2 = If you would like to add tracking information to the email body, you can use the substitution variables TrackingNumber, ShippingMethod, and TrackingLink, surrounded by square brackets, as shown in the example below:
fulfillment.shipments.packingSlipEmail.explanation.3 = TrackingNumber: [TrackingNumber]
fulfillment.shipments.packingSlipEmail.explanation.4 = ShippingMethod: [ShippingMethod]
fulfillment.shipments.packingSlipEmail.explanation.5 = You can track your shipment by going to this link: [TrackingLink]
fulfillment.shipments.packingSlipFooter.label = Packing slip footer 
fulfillment.shipments.packingSlipFooter.explanation = Text to be displayed at the bottom of every packing slip. 
fulfillment.shipments.showCustEmailOnPackingSlip.label = Show on packing slips - Customer email address 
fulfillment.shipments.showCustEmailOnPackingSlip.explanation = Enable this setting to display the customer's email address on packing slips. 
fulfillment.shipments.showCustPhoneOnPackingSlip.label = Show on packing slips - Customer phone number 
fulfillment.shipments.showCustPhoneOnPackingSlip.explanation = Enable this setting to display the customer's phone number on packing slips. 
fulfillment.shipments.shipFromAddressOfLocation.label = Ship from address of location 
fulfillment.shipments.shipFromAddressOfLocation.explanation = By default, SOS displays the company header information on a packing slip. Enable this setting to use the address of the location from which you are shipping instead. Note that this also determines the company name and address shown on payment quick views.
fulfillment.shipments.defaultCCShipment.label = Default cc for shipments 
fulfillment.shipments.defaultCCShipment.explanation = If an email address is entered, the recipient will be copied on all emailed shipments. 
fulfillment.shipments.showWarrantyOnPackingSlip.label = Show warranty on serial units 
fulfillment.shipments.showWarrantyOnPackingSlip.explanation = Enable this setting to show warranty information next to serial numbers on your shipments.

fulfillment.pickTickets.pickTicketNumber.label = Pick ticket numbering
fulfillment.pickTickets.pickTicketNumber.explanation = ""
fulfillment.pickTickets.pickTicketHeaderText.label = Pick ticket title 
fulfillment.pickTickets.pickTicketHeaderText.explanation = Change this value if a different title (for example, Pick Slip) is desired when printing or emailing pick tickets. The title should not be more than 50 characters. 
fulfillment.pickTickets.pickTicketFooter.label = Pick ticket footer 
fulfillment.pickTickets.pickTicketFooter.explanation = The text to be displayed at the bottom of every pick ticket. 
fulfillment.pickTickets.replyEmailPickTicket.label = Pick ticket Reply-To
fulfillment.pickTickets.replyEmailPickTicket.explanation = The email address where you will receive replies to your pick ticket emails.
fulfillment.pickTickets.pickTicketEmailText.label = Pick ticket message 
fulfillment.pickTickets.pickTicketEmailText.explanation = The body of the email message to be sent with your pick tickets. Do not use HTML. 
fulfillment.pickTickets.pickTicketSerialsLots.label = Serials/lots on pick tickets
fulfillment.pickTickets.pickTicketSerialsLots.explanation = Check this box if you want to specify serial numbers and lot numbers on pick tickets. 
fulfillment.pickTickets.defaultCCPickTicket.label = Default cc for pick tickets 
fulfillment.pickTickets.defaultCCPickTicket.explanation = If an email address is entered, the recipient will be copied on all emailed pick tickets. 

payments.general.avsAllowed.label = Require zip code verification 
payments.general.avsAllowed.explanation = Enable this option to require the customer's billing ZIP code to match the card issuer's records. If the ZIP code does not match, the transaction will be declined.
payments.general.cvvAllowed.label = Require CVV verification 
payments.general.cvvAllowed.explanation = Enable this option to require CVV verification for all transactions. If the CVV entered by the customer does not match the card issuer's records, the transaction will be declined.
payments.general.paymentNumber.label = Payments numbering
payments.general.paymentNumber.explanation = If desired, you may enter a prefix that will be automatically attached to all payment transactions. If you want to (re)set the next payment number, you can do that as well. Both fields are optional. You can always enter a transaction number manually when creating or editing a transaction.
payments.general.companyName.label = Company name
payments.general.companyName.explanation = Your company name as you want it to appear to customers making an online payment.
payments.general.template.label = Invoice template
payments.general.template.explanation = The template used to generate the PDF of an invoice when it is downloaded by a customer making an online payment.
payments.general.paymentNotifyEmail.label = Default cc for payments
payments.general.paymentNotifyEmail.explanation = If an email address is entered, the recipient will be copied automatically on all emailed payment transactions.

production.workOrders.workOrderNumber.label = Work order numbering
production.workOrders.workOrderNumber.explanation = ""
production.workOrders.workOrderHeaderText.label = Work order title 
production.workOrders.workOrderHeaderText.explanation = Change this value if a different title (for example, Job Order) is desired when printing or emailing work orders. The title should not be more than 50 characters.
production.workOrders.replyEmailWO.label = Work order Reply-to
production.workOrders.replyEmailWO.explanation = The email address where you will receive replies to your work order emails.
production.workOrders.workOrderEmail.label = Work order message
production.workOrders.workOrderEmail.explanation = The body of the email message to be sent with your work orders. Do not use HTML.
production.workOrders.workOrderFooter.label = Work order footer
production.workOrders.workOrderFooter.explanation = Text to be displayed at the bottom of every work order.
production.workOrders.defaultCCWorkOrder.label = Default cc for work orders
production.workOrders.defaultCCWorkOrder.explanation = If an email address is entered, the recipient will be copied on all emailed work orders.

production.builds.buildNumber.label = Build numbering
production.builds.buildNumber.explanation = ""

production.processes.processNumber.label = Process numbering
production.processes.processNumber.explanation = ""

production.jobs.jobNumber.label = Job numbering
production.jobs.jobNumber.explanation = ""
production.jobs.jobTrackingEnabled.label = Job tracking
production.jobs.jobTrackingEnabled.explanation = Check this box to track transactions by job.

purchasing.general.searchByAnyPartOfVendor.label = Search any part of vendor name
purchasing.general.searchByAnyPartOfVendor.explanation = Check this option to search for vendors by any part of the name, instead of only what the name starts with.
purchasing.general.defaultExpenseAccount.label = Default expense account
purchasing.general.defaultExpenseAccount.explanation = Default expense account for expense items.
purchasing.general.updateDefaultCostOnPurchase.label = Update default cost
purchasing.general.updateDefaultCostOnPurchase.explanation = Check this box to update the default cost of an item automatically when a PO or item receipt is issued for that item.
purchasing.general.includeWOonReorderReport.label = Include work orders on reorder report
purchasing.general.includeWOonReorderReport.explanation = Check this box to include work order calculations on the Reorder Report.
purchasing.general.showCustomerOnPurchaseForms.label = Enter customer on line items
purchasing.general.showCustomerOnPurchaseForms.explanation = Check this box to allow the customer to be specified on line items of a purchasing form, if you are purchasing an item for a specific customer rather than for general inventory.
purchasing.general.showWeightOnPurchasingForms.label = Show weight on purchasing forms
purchasing.general.showWeightOnPurchasingForms.explanation = Check this box to display the weight of each item, as well as the total weight of all items, on purchasing forms.
purchasing.general.showVolumeOnPurchasingForms.label = Show volume on purchasing forms
purchasing.general.showVolumeOnPurchasingForms.explanation = Check this box to display the volume of each item, as well as the total volume of all items, on purchasing forms.

purchasing.purchaseOrders.purchaseOrderNumber.label = Purchase order numbering
purchasing.purchaseOrders.purchaseOrderNumber.explanation = ""
purchasing.purchaseOrders.defaultCCPO.label = Default cc for purchase orders
purchasing.purchaseOrders.defaultCCPO.explanation = If an email address is entered, the recipient will be copied on all emailed purchase orders.
purchasing.purchaseOrders.defaultLocationForPurchasing.label = Default ship-to location for purchase orders
purchasing.purchaseOrders.defaultLocationForPurchasing.explanation = Specifies the default location to which purchase orders will be shipped.
purchasing.purchaseOrders.requireApprovalPO.label = Require approval for purchase orders
purchasing.purchaseOrders.requireApprovalPO.explanation = If this box is checked, a company administrator must approve each purchase order before it can be emailed.
purchasing.purchaseOrders.replyEmailPO.label = Purchase orders Reply-To
purchasing.purchaseOrders.replyEmailPO.explanation = The email address where you will receive replies to your purchase order emails.
purchasing.purchaseOrders.purchaseOrderEmail.label = Purchase order message
purchasing.purchaseOrders.purchaseOrderEmail.explanation = The body of the email message to be sent with your purchase orders. Do not use HTML.
purchasing.purchaseOrders.purchaseOrderFooter.label = Purchase order footer
purchasing.purchaseOrders.purchaseOrderFooter.explanation = Text to be displayed at the bottom of every purchase order.
purchasing.purchaseOrders.suggestPOQuantity.label = Suggest purchase order quantities
purchasing.purchaseOrders.suggestPOQuantity.explanation = Check this box to have SOS automatically suggest a reorder quantity when an item is entered on a purchase order.
purchasing.purchaseOrders.syncPurchaseOrders.label = Sync purchase orders
purchasing.purchaseOrders.syncPurchaseOrders.explanation = Check this box to synchronize purchase orders with QuickBooks Online.
purchasing.purchaseOrders.journalEntryDropShipPO.label = Automate drop ship purchase orders
purchasing.purchaseOrders.journalEntryDropShipPO.explanation = If this box is checked, SOS closes the purchase order automatically and creates a journal entry in QuickBooks Online to record the payable and cost of goods sold. Uncheck this box to disable this behavior.

purchasing.itemReceipts.itemReceiptNumber.label = Item receipt numbering
purchasing.itemReceipts.itemReceiptNumber.explanation = ""
purchasing.itemReceipts.defaultSyncItemReceipts.label = Default accounting transaction type for item receipts
purchasing.itemReceipts.defaultSyncItemReceipts.explanation = Sets the default accounting transaction type when creating a new item receipt. This can be overridden on individual item receipts.

purchasing.returnsToVendors.returnToVendorNumber.label = Returns to vendors numbering
purchasing.returnsToVendors.returnToVendorNumber.explanation = ""

rentals.rentalReturns.rentalReturnNumber.label = Rental return numbering
rentals.rentalReturns.rentalReturnNumber.explanation = ""
rentals.rentals.rentalHeaderText.label = Rental title
rentals.rentals.rentalHeaderText.explanation = Change this value if a different title (for example, Rental Ticket) is desired when printing or emailing rentals. The title should not be more than 50 characters.
rentals.rentals.rentalFooter.label = Rental footer
rentals.rentals.rentalFooter.explanation = Text to be displayed at the bottom of every rental.
rentals.rentals.replyEmailRental.label = Rental Reply-To
rentals.rentals.replyEmailRental.explanation = The email address where you will receive replies to your rental emails.
rentals.rentals.rentalEmailText.label = Rental message
rentals.rentals.rentalEmailText.explanation = The body of the email message to be sent with your rentals. Do not use HTML.

rentals.rentals.rentalNumber.label = Rental numbering
rentals.rentals.rentalNumber.explanation = ""
purchasing.returnToVendors.returnToVendorNumber.label = Returns to vendors numbering

sales.customerPortal.portalEnabled.label = Enabled
sales.customerPortal.portalEnabled.explanation = Check this box to enable the portal for your customers.
sales.customerPortal.portalDomain.label = Portal subdomain
sales.customerPortal.portalDomain.explanation = This is the URL to which you'll direct your customers.
sales.customerPortal.portalDomain.addressLabel = Portal address
sales.customerPortal.portalCompanyName.label = Company name for portal
sales.customerPortal.portalCompanyName.explanation = Enter the company name you want displayed to your customers. Leave this blank to default to the company name you entered in company settings.
sales.customerPortal.portalFooter.label = Footer
sales.customerPortal.portalFooter.explanation = Enter the text to be displayed at the bottom of all portal pages. Typically includes disclaimers, contact info, etc.
sales.customerPortal.portalPasswordOptional.label = Require password
sales.customerPortal.portalPasswordOptional.explanation = If enabled, requires the customer to enter a password to access information in the customer portal.
sales.customerPortal.showAssignedUser.label = Show assigned representative
sales.customerPortal.showAssignedUser.explanation = If enabled, allows the customer to see the name of the person assigned to the order.

sales.customerPortal.portalDomain.warning = This portal subdomain is unavailable.

sales.general.defaultTaxCode.label = Default tax code
sales.general.defaultTaxCode.explanation = The default tax code if you use the Sales Tax Center in QuickBooks Online. If you do not use the Sales Tax Center, this setting has no effect.
sales.general.retrieveQuantityOnHand.label = Show available for sale on forms
sales.general.retrieveQuantityOnHand.explanation = Show available for sale on forms
sales.general.defaultTaxRate.label = Default tax rate
sales.general.defaultTaxRate.explanation = Default sales tax rate, specified as a percentage. If you have multiple locations with varying tax rates, you can leave this setting blank and specify the rate for each location in the Sales tax rate setting of the Location edit page.
sales.general.defaultDiscountTaxable.label = Discount taxable
sales.general.defaultDiscountTaxable.explanation = Check this box if discounts are taxable. You can override this setting on any sales form.
sales.general.defaultShippingTaxable.label = Shipping is taxable
sales.general.defaultShippingTaxable.explanation = Check this box if shipping costs on sales forms are taxable.
sales.general.defaultPaymentMethod.label = Default payment method
sales.general.defaultPaymentMethod.explanation = Default payment method for customer payments.
sales.general.defaultTerms.label = Default terms
sales.general.defaultTerms.explanation = Default terms specified in QuickBooks, or in SOS, if not connected to QuickBooks.
sales.general.findCustomersByFullName.label = Find customers by long name
sales.general.findCustomersByFullName.explanation = Check this option to search for customers by their long name, which includes any parent customers, instead of the regular customer name. This is helpful if you use subcustomers.
sales.general.searchByAnyPartOfCustomer.label = Search any part of customer name
sales.general.searchByAnyPartOfCustomer.explanation = Check this option to allow searching for a customer by any part of its name, instead of only the beginning of the name.
sales.general.autoShipInvoices.label = Auto-ship invoices
sales.general.autoShipInvoices.explanation = Check this box to create a shipment automatically for new invoices created in QuickBooks Online.
sales.general.autoShipSalesReceipts.label = Auto-ship sales receipts
sales.general.autoShipSalesReceipts.explanation = Check this box to create a shipment automatically for new sales receipts created in QuickBooks Online.
sales.general.autoSOForInvoice.label = Auto-sales order invoices
sales.general.autoSOForInvoice.explanation = Check this box to create a sales order automatically for new invoices created in QuickBooks Online. This setting will be ignored if a shipment is automatically created for the invoice.
sales.general.lineItemDiscountsEnabled.label = Enable line-item discounts on sales forms
sales.general.lineItemDiscountsEnabled.explanation = Check this box to display a regular price, discount percentage, and sale price on each line item of your sales forms.
sales.general.marginPricingEnabled.label = Show cost/markup on sales forms
sales.general.marginPricingEnabled.explanation = Check this box to display the markup on each item—and the total cost for that line—on sales forms. The user must also have the View Costs permission or be an administrator.
sales.general.markupOnActualCost.label = Markup on actual cost
sales.general.markupOnActualCost.explanation = Check this box to use actual cost (instead of standard cost) when showing cost/markup on sales forms.
sales.general.showWeightOnSalesForms.label = Show weight on sales forms
sales.general.showWeightOnSalesForms.explanation = Check this box to display the weight of each item, as well as the total weight of all items, on sales forms.
sales.general.showVolumeOnSalesForms.label = Show volume on sales forms
sales.general.showVolumeOnSalesForms.explanation = Check this box to display the volume of each item, as well as the total volume of all items, on sales forms.
sales.general.includeIncomingInAvailableForSale.label = Include incoming in available
sales.general.includeIncomingInAvailableForSale.explanation = Check this box if you want to include inbound goods (e.g., purchase orders, rentals due, etc.) in your available-for-sale calculations. Normally, this setting is enabled only if your incoming goods have very reliable delivery dates. If you change this option, it might take a little time for all your available-for-sale values to be updated.
sales.general.showInStockOnlySOToPT.label = Show only in-stock
sales.general.showInStockOnlySOToPT.explanation = Check this box if you want to show only items in-stock when generating a pick ticket or shipment from a sales order or sales receipt. You can override this option by entering any other items manually.
sales.general.defaultDepositAssetAccount.label = Default deposit asset account
sales.general.defaultDepositAssetAccount.explanation = Default asset account for customer deposits. Most commonly, this is an undeposited funds account.
sales.general.defaultDepositLiabilityAccount.label = Default deposit liability account
sales.general.defaultDepositLiabilityAccount.explanation = Default liability account for customer deposits.

sales.salesOrders.salesOrderNumber.label = Sales order numbering
sales.salesOrders.expandKitsOnSalesOrder.label = Expand kits on sales orders
sales.salesOrders.expandKitsOnSalesOrder.explanation = Check this box to expand kits automatically upon saving a sales order.
sales.salesOrders.salesOrderText.label = Sales order title
sales.salesOrders.salesOrderText.explanation = Change this value if you want a different title when printing or emailing sales orders. For example, some people use Sales Acknowledgement instead. The title should be no more than 50 characters.
sales.salesOrders.replyEmailSO.label = Sales order Reply-To
sales.salesOrders.replyEmailSO.explanation = The email address where you will receive replies to your sales order emails.
sales.salesOrders.salesOrderEmail.label = Sales order message 
sales.salesOrders.salesOrderEmail.explanation.1 = The body of the email message to be sent with your sales orders. Do not use HTML. 
sales.salesOrders.salesOrderEmail.explanation.2 = If you are on the Pro plan and using the customer portal, you can use the substitution variables StatusLink and PortalPassword, surrounded by square brackets, to provide access to the portal for your customers, as shown in the example below:
sales.salesOrders.salesOrderEmail.explanation.3 = Order Status Portal Link: [StatusLink]
sales.salesOrders.salesOrderEmail.explanation.4 = Password for Portal: [PortalPassword]
sales.salesOrders.salesOrderFooter.label = Sales order footer 
sales.salesOrders.salesOrderFooter.explanation = Text to be displayed at the bottom of every sales order. 
sales.salesOrders.defaultCCSalesOrder.label = Default cc for sales orders 
sales.salesOrders.defaultCCSalesOrder.explanation = If an email address is entered, the recipient will be copied automatically on all emailed sales orders. 
sales.salesOrders.editLocksEnabled.label = Lock sales orders when editing 
sales.salesOrders.editLocksEnabled.explanation = Check this box to prevent users from editing a sales order that someone else already has open.

sales.estimates.estimateNumber.label = Estimate numbering
sales.estimates.estimateText.label = Estimate title 
sales.estimates.estimateText.explanation = Change this value if you want a different title when printing or emailing estimates. For example, some people use Quote instead. The title should be no more than 50 characters. 
sales.estimates.replyEmailEstimate.label = Estimate Reply-To
sales.estimates.replyEmailEstimate.explanation = The email address where you will receive replies to your estimate emails.
sales.estimates.estimateEmail.label = Estimate message
sales.estimates.estimateEmail.explanation = The body of the email message to be sent with your estimates. Do not use HTML.
sales.estimates.estimateFooter.label = Estimate footer
sales.estimates.estimateFooter.explanation = Text to be displayed at the bottom of every estimate. 
sales.estimates.defaultCCEstimate.label = Default cc for estimates 
sales.estimates.defaultCCEstimate.explanation = If an email address is entered, it will be copied automatically on all emailed estimates. 

sales.invoices.invoiceNumber.label = Invoice numbering
sales.invoices.useQBInvoiceNumber.label = Use QuickBooks invoice numbers 
sales.invoices.useQBInvoiceNumber.explanation = If this setting is enabled, SOS Inventory will leave the invoice number blank when sending an invoice to QuickBooks, and QuickBooks will generate an invoice number.
sales.invoices.replyEmailInvoice.label = Invoice Reply-To
sales.invoices.replyEmailInvoice.explanation = The email address where you will receive replies to your invoice emails.
sales.invoices.invoiceEmail.label = Invoice message
sales.invoices.invoiceEmail.explanation.1 = The body of the email message to be sent with your invoices. Do not use HTML.
sales.invoices.invoiceEmail.explanation.2 = If you have the SOS Pay add-on, you can use the substitution variable PaymentLink, surrounded by square brackets, to allow customers to pay invoices online, as shown in the example below:
sales.invoices.invoiceEmail.explanation.3 = You can pay it by going to [PaymentLink]
sales.invoices.invoiceFooter.label = Invoice footer
sales.invoices.invoiceFooter.explanation = Text to be displayed at the bottom of every invoice.
sales.invoices.defaultCCInvoice.label = Default cc for invoices
sales.invoices.defaultCCInvoice.explanation = If an email address is entered, it will be copied automatically on all emailed invoices.
sales.invoices.useShippingCostFromShipment.label = Use shipping cost from shipment
sales.invoices.useShippingCostFromShipment.explanation = By default, SOS will use the shipping cost specified on the sales order when invoicing. Enable this setting to use the shipping cost from the associated shipment instead.
sales.invoices.useSalesOrderNumber.label = Use sales order number
sales.invoices.useSalesOrderNumber.explanation = By default, an invoice created from a sales order will use the invoice’s own transaction numbering. Enable this setting to have the generated invoice inherit its number from that sales order instead of the next invoice number.

sales.salesReceipts.salesReceiptNumber.label = Sales receipt numbering
sales.salesReceipts.replyEmailSalesReceipt.label = Sales receipt Reply-To
sales.salesReceipts.replyEmailSalesReceipt.explanation = The email address where you will receive replies to your sales receipt emails.
sales.salesReceipts.salesReceiptEmail.label = Sales receipt message 
sales.salesReceipts.salesReceiptEmail.explanation.1 = The body of the email message to be sent with your sales receipts. Do not use HTML.
sales.salesReceipts.salesReceiptEmail.explanation.2 = If you are on the Pro plan and using the customer portal, you can use the substitution variables StatusLink and PortalPassword, surrounded by square brackets, to provide access to the portal for your customers, as shown in the example below:
sales.salesReceipts.salesReceiptEmail.explanation.3 = Order Status Portal Link: [StatusLink]
sales.salesReceipts.salesReceiptEmail.explanation.4 = Password for Portal: [PortalPassword]
sales.salesReceipts.salesReceiptFooter.label = Sales receipt footer
sales.salesReceipts.salesReceiptFooter.explanation = Text to be displayed at the bottom of every sales receipt.
sales.salesReceipts.defaultCCSalesReceipt.label = Default cc for sales receipts
sales.salesReceipts.defaultCCSalesReceipt.explanation = If an email address is entered, it will be copied automatically on all emailed sales receipts
sales.salesReceipts.includeSalesReceiptsInAvailableForSale.label = Include sales receipts in available
sales.salesReceipts.includeSalesReceiptsInAvailableForSale.explanation = Check this box if you want to include sales receipts in your available-for-sale calculations. If this option is turned off, only sales orders are included. If you change this option, it might take some time for all of your available-for-sale values to be updated.

sales.rmas.rmaNumber.label = RMA numbering
sales.rmas.rmaFooter.label = RMA footer
sales.rmas.rmaFooter.explanation = The text to be displayed at the bottom of every return merchandise authorization.
sales.rmas.replyEmailRMA.label = RMA Reply-To
sales.rmas.replyEmailRMA.explanation = The email address where you will receive replies to your RMA emails.
sales.rmas.rmaEmailText.label = RMA message
sales.rmas.rmaEmailText.explanation = The body of the email message to be sent with your RMAs. Do not use HTML.

sales.returns.returnNumber.label = Return numbering

customerPortal.general.PortalEnabled.label = Enabled
customerPortal.general.PortalEnabled.explanation = Check this box to enable the portal for your customers.
customerPortal.general.PortalDomain.label = Portal subdomain
customerPortal.general.PortalDomain.explanation = This is the URL to which you'll direct your customers.
customerPortal.general.PortalDomain.addressLabel = Portal address
customerPortal.general.PortalCompanyName.label = Company name for portal
customerPortal.general.PortalCompanyName.explanation = Enter the company name you want displayed to your customers. Leave this blank to default to the company name you entered in company settings.
customerPortal.general.PortalFooter.label = Footer
customerPortal.general.PortalFooter.explanation = Enter the text to be displayed at the bottom of all portal pages. Typically includes disclaimers, contact info, etc.
customerPortal.general.PortalPasswordOptional.label = Require password
customerPortal.general.PortalPasswordOptional.explanation = If enabled, requires the customer to enter a password to access information in the customer portal.
customerPortal.general.showAssignedUser.label = Show assigned representative
customerPortal.general.showAssignedUser.explanation = If enabled, allows the customer to see the name of the person assigned to the order.

user.general.dateFormat.label = Date format
user.general.timeZone.label = Time zone
user.general.timeZone.explanation = Select the current time at your location. If your local time (relative to GMT) changes throughout the year, might need to adjust this setting again. Alternating between Standard Time and Daylight Savings Time is one possible example, depending on your locale.
user.general.notificationMethod.label = Notification method
user.general.notificationMethod.explanation = In addition to the notifications sent to you within the SOS Inventory app, you may opt in to be notified via email, text, both—or opt out of receiving email and text message notifications. Messaging fees may apply, so check with your mobile carrier if you are unsure.
user.general.name.label = Display name
user.general.name.explanation = The name you want displayed on your User Menu.
user.general.email.label = Email
user.general.confirmEmail.label = Confirm email
user.general.email.explanation = The user email address tied to your SOS Inventory account.
user.general.passwordQuestion.label = Security question
user.general.passwordQuestion.explanation = Select a security question in case you need to reset your SOS password.
user.general.passwordAnswer.label = 
user.general.passwordAnswer.explanation = 
user.general.passwordAnswer.label = Security question answer
user.general.passwordAnswer.explanation = SOS will use the answer you provide to help confirm your identity should you need to reset your password.
user.general.smsEnabled.label = Receive notifications via SMS
user.general.smsEnabled.explanation = Check this box to receive text message notifications from SOS. You will need to select your mobile carrier and enter your mobile number.
user.general.mobileCarrier.label = Mobile carrier
user.general.mobileNumber.label = Mobile number

user.general.dateFormat.M/d/yyyy = month / day / year
user.general.dateFormat.dd/MM/yyyy = day / month / year

user.general.notificatioMethod.None = Don't email or text me
user.general.notificatioMethod.Email = Email me
user.general.notificatioMethod.Text = Text me
user.general.notificatioMethod.EmailText = Email me and text me

user.general.passwordQuestion.SchoolName = What was the name of your elementary / primary school?
user.general.passwordQuestion.HouseStreetNumber = What is the street number of the house you grew up in?
user.general.passwordQuestion.CityWhereParentsMet = In what city or town did your mother and father meet?
user.general.passwordQuestion.FirstCarColor = What was the color of your first car?
user.general.passwordQuestion.ChildhoodFriendName = What is the name of your favorite childhood friend?
user.general.passwordQuestion.FirstJobCity = In what city was your first job?

user.general.mobileCarrier.ATT = AT&T
user.general.mobileCarrier.AU = Australia (any)
user.general.mobileCarrier.Orange = Orange
user.general.mobileCarrier.Sprint = Sprint
user.general.mobileCarrier.Telus = Telus
user.general.mobileCarrier.TMobile = T-Mobile
user.general.mobileCarrier.Verizon = Verizon

user.masterAdmin = This is the master administrator for this account, and has all privileges.

connections.quickbooks.neverConnectQBO.label = Never connect
connections.quickbooks.neverConnectQBO.explanation = Check this box if you don't ever intend to connect to QuickBooks Online. This hides several menu options to make the user experience a little better. You can change this setting at any time. Best used by companies that use SOS Inventory as a stand-alone product.
connections.quickbooks.autoSync.label = Automatic sync
connections.quickbooks.autoSync.explanation = When enabled, SOS Inventory will automatically sync with QuickBooks Online according to the schedule you specify. Choose Never if you want to do all synchronizations manually.
connections.quickbooks.postCOGStoQB.label = Post COGS to QuickBooks
connections.quickbooks.postCOGStoQB.explanation = Uncheck this box if you do not want SOS to post cost of goods sold to Quickbooks. This option is enabled by default, and we recommend that you leave it enabled. However, manual control over COGS postings might be desired in certain situations—for example, if postings are being duplicated due to QuickBooks Online Inventory tracking. Check with your accountant and/or SOS Support if you are unsure.
connections.quickbooks.classTrackingEnabled.label = Class tracking
connections.quickbooks.classTrackingEnabled.explanation = Check the box to enable class tracking, which allows grouping transactions by items within the same class for reporting purposes. If selected on transactions, the classes will sync with QuickBooks Online.
connections.quickbooks.departmentTrackingEnabled.label = Department tracking
connections.quickbooks.departmentTrackingEnabled.explanation = Check the box to enable department tracking, which allows grouping transactions for reporting purposes. If selected on transactions, the departments will sync with QuickBooks Online.
connections.quickbooks.syncSOStoQBO.label = Sync SOS Inventory to QuickBooks
connections.quickbooks.syncQBOtoSOS.label =  Sync QuickBooks to SOS Inventory
connections.quickbooks.syncDirections.label = QuickBooks sync
connections.quickbooks.syncDirections.explanation = The Sync SOS Inventory to QuickBooks and Sync QuickBooks to SOS Inventory options work together to determine the overall synchronization of data. They can be used separately to provide a single direction flow. If both options are checked, synchronization will be bi-directional. If neither option is checked, data does not synchronize in either direction.
connections.quickbooks.disconnect.label = Disconnect
connections.quickbooks.disconnect.explanation = Click the button to disconnect from QuickBooks Online. If you disconnect, you will not be able to synchronize until you reconnect.

autoSyncOptions.Hourly = Hourly
autoSyncOptions.Daily = Daily
autoSyncOptions.Weekly = Weekly
autoSyncOptions.Never = Never
user.general.maxUserWarning = You currently have {{activeUsers}} active users in your account. Adding this user exceeds your included user limit and will incur an additional {{fee}} per {{feePeriod}}, as specified in your plan.
user.general.trialMaxUserWarning = You currently have {{activeUsers}} active users in your account. Adding this user exceeds your included user limit and will incur an additional {{fee}} per {{feePeriod}} after your trial ends, as specified in your plan.
user.general.feePeriod.month = month 
user.general.feePeriod.year = year 

[privilege]
activityLog = View activity Log
qboAccounts = View chart of accounts
qboBills = View bills
qboBillPayments = View bill payments
qboCashPurchases = View cash purchases
qboChecks = View checks
qboCharges = View credit card charges
qboEmployees = View employees
qboJournalEntries = View journal entries
qboPaymentsReceived = View payments received
qboSalesReceipts = View sales receipts
sync = Synchronize

ViewEstimates = View estimates
EditEstimates = Add/edit/delete estimates
ViewSalesOrders = View sales orders
EditSalesOrders = Add/edit/delete sales orders
VInv = View invoices
EInv = Add/edit/delete invoices
ViewShipments = View shipments
EditShipments = Add/edit/delete shipments
ViewCustomers = View customers
EditCustomers = Add/edit/delete customers
EditSalesReps = Add/edit/delete sales reps
salesSettings = Modify sales Settings
EditShippingMethods = Add/edit/delete Shipping methods
AdjustInventory = Adjust
TransferInventory = Transfer
BuildAssemblies = Builds / processes
ViewInventory = View inventory
ViewItems = View items
EditItems = Add/edit/delete items
inventorySettings = Modify inventory settings
purchasingSettings = Modify purchasing settings
ViewVendors = View vendors
EditVendors = Add/edit/delete vendors
ReceiveInventory = Receive inventory
ViewPOs = View purchase orders
EditPOs = Add/edit/delete purchase orders
ApprovePOs = Approve purchase orders
ViewJobs = View jobs
EditJobs = Add/edit/delete jobs
ViewRentals = View rentals
EditRentals = Add/edit/delete rentals
ViewWorkers = View workers
EditWorkers = Add/edit/delete workers
ViewCosts = View item costs
CCP = Change pricing on sales
PrPa = Process credit card or ACH payments

ProcessCCOrACH = Process CC or ACH
Receive = Receive
ChangeSalesPricing = Change sales pricing

Admin = Admin
Inventory = Inventory
Purchasing = Purchasing
QuickBooks = Quickbooks
Production = Production
Rental = Rental
Sales = Sales

View = View
ViewAddEditDelete = View/add/edit/delete
AddEditDelete = Add/edit/delete

[upsAccount]
LinkedUpsAccounts = Linked UPS accounts
AddAccount = Add account
ConnectToUps = Connect to UPS
EnterInfo = Enter your UPS shipping account information
NeedAUpsAccount = Need a UPS account?
FindYourAccountNumber.1 = To find your account number, log in to UPS at 
FindYourAccountNumber.2 = , click on your initials icon at the right of the page, and choose "Accounts and Payment."

[accountInformation]

AreYouSureYouWantToCancel = If you're sure you'd like to cancel, please share the reason below so we can continue to make improvements to our services. Then, click the blue CANCEL button. As always, if you're having any issues with SOS Inventory, we're here to help! Just click the green KEEP button and give us a call at 817-422-5909 for training or personal support. 
SorryToSeeYouGo = We're sorry to see you go
KeepSubscription = Keep subscription
CancelSubscription = Cancel subscription
ClickLinkToRemovePayment = Click the link to remove your payment information. This will cause your subscription to expire on the date listed above.
CancelSubscription = Cancel subscription
Cancellation = Cancellation
subscriptionExpiration = Subscription expiration
paymentMethod = Payment method
plan = Plan
currentCharges = Current charges
annualBilling = Annual billing
paymentHistory = Payment history (click to download PDF invoice)
subscriptionInvoice = subscription invoice

CurrentPlan = Current plan
TermsOfServiceReaffirmation = By clicking to change your plan below, I reaffirm that I agree to SOS Inventory's
TermsOfService = Terms of Service
SwitchToAnnual = Switch to annual and get two months free!
SwitchToMonthly = Switch to monthly
EditPaymentInformation = Edit payment information
ChangePlans = Change plans
CardChargedOnListedDate = Your card will be charged on the date listed above.
ClickToChoosePlan = Click the button to choose which SOS plan you wish to use (Companion, Plus, or Pro).

subscription = subscription
additionalUsers = additional users
additionalSmsUsers = additional SMS users
integrations = integrations
discount = discount
salesTax = sales tax

monthly = monthly
month = month
annual = annual
year = year

SalesOrders = Sales orders
BestInClassQbo = Best-in-class QuickBooks integration
UnlimitedLocations = Unlimited locations
SerialLotTracking = Serial/lot tracking
Barcoding = Barcoding
JobCosting = Job costing
AdvancedManufacturing = Advanced manufacturing
CustomerPortal = Customer portal
usersIncluded = users included.
eachAdditionalUser = each additional user.
Choose = Choose

BusinessClosed = Business closed
CompanySoldOrMerged = Company sold or merged
SwitchedSoftwareProvider = Switched software provider
NoLongerUsingQuickBooksOnline = No longer using QuickBooks Online
NeedMoreTime = Need more time
NotAGoodFit = Not a good fit
PricingConcerns = Pricing concerns
SoftwareBugs = Software bugs
SlowPerformance = Slow performance
PoorCustomerService = Poor customer service
DidntUnderstandHowToUseSoftware = Didn't understand how to use software
ThirdPartyIntegrationChallenges = Third party integration challenges
CreatingNewSOSInventoryAccount = Creating new SOS Inventory account
Other = Other

[ftp]
Outbound = Outbound
Inbound = Inbound
OutboundInbound = "Outbound & Inbound"

connectionType.hoverHelp = Select if the connection is for data inbound to SOS, outbound from SOS, or for both.
enabled.hoverHelp = Check this box to enable this FTP connection.
credential.hoverHelp = You should get this from whoever set up your FTP account.
remoteHost.hoverHelp = FTP server for this connection.
path.hoverHelp = Path to the directory on the remote server we should place files.

[plan]
colon.CurrentPlan = Current plan:
ClickHereForDetailedComparison = Click here for a detailed comparison of the plans

[quickBooks]
header = QuickBooks Sync Settings
description = Your account is not currently connected to a QuickBooks Online company. To make this connection, click the button below and follow the instructions. After you make a connection, your account will begin to synchronize with QuickBooks Online. Normally this takes less than 30 minutes, although it can take up to 24 hours. You will receive an email when the synchronization is complete. You can continue to use SOS Inventory while it is synchronizing.
alert = NOTE: Once your SOS Inventory account has synchronized with QuickBooks Online, you may not connect it to another QuickBooks Online account. If you have started a new QuickBooks Online account or reset QuickBooks Online, please reach out to
connect.hoverHelp = Click the button above to connect SOS Inventory to QuickBooks Online.
RemoveConnectionToQuickBooks = Remove connection to QuickBooks
ConfirmationMessage = Are you sure that you want to disconnect from QuickBooks?
DisconnectSuccess = Connection to Quickbooks succesfully removed
ConnectError = An error occured when attempting to connect to QuickBooks

[shipStation]
pageTitle = Configure ShipStation for use with SOS Inventory
header = To use ShipStation with SOS Inventory, follow these steps. If you run into any problems, contact support@sosinventory.com for assistance.
1 = Register your Custom Store in the ShipStation application. To do this, click on your "Account Settings" (the gear icon in the top right), then "Selling Channels" and "Store Setup" from the sidebar on the left. Click "+ Connect a Store or Marketplace" and choose the "Custom Store" option.
2 = Enter the following in the Username field.
3 = Enter the following in the Password field.
4 = Enter the following in the URL to Custom XML Page field.
5 = Leave the default values in the other fields as they are.
6 = Click the Finish button.
7 = Back on this page, check the Enabled checkbox, change the "Send for SKU" and "Send for description" selections as appropriate, and click Save.
footer = After completing these steps, SOS Inventory is connected to ShipStation. You can go to ShipStation to retrieve shipments from SOS as needed. When you ship in ShipStation, the tracking information and cost will be posted back to SOS.

sendForSku.Sku = SKU
sendForSku.ItemNumber = Item ID
sendForSku.ItemName = Item name

sendForDescription.ItemName = Item name
sendForDescription.ItemDescription = Item description
sendForDescription.ShipmentDescription = Shipment description

[download]
ItemHistoryDownloadFileName = ItemHistory
RentalHistoryDownloadFileName = RentalHistory

[shopify]
ConnectError = Failed to connect to Shopify. Please try again.
ConnectSuccess = Successfully connected to Shopify. Please verify your settings and enable data flow if desired.
SecurityValidationFailed = Security validation failed. Invalid state.
MissingParameters = Missing required parameters. Please try again.
ConnectionSuccess = Success! Your Shopify store is now connected.
SaveCartError = Failed to save cart
CartIdError = Failed to get cart ID after save
ConfigFetchError = Failed to fetch Shopify configuration
UnexpectedError = An unexpected error occurred while connecting to Shopify
Connecting = Connecting...
ConnectButton = Connect to Shopify
UpdateConnectionButton = Update your connection to Shopify
AppCredsConnectButton = Connect
AppCredsConnectSuccess = Shopify connection established. Setup is running in the background.
DisconnectConfirmation = This will remove SOS Inventory from your Shopify store and clear all connection details. Are you sure you want to disconnect?

[cart]
private = Private app
custom = Custom app
connector = Connector app
appCreds = Shopify App Credentials
Instructions.header = Instructions

AutoDetect = Auto-detect
SalesOrders= Sales orders
SalesReceipts = Sales receipts
DontImport = Don't import

link.instructions.SosHelpCenter = SOS Inventory Help Center

Shopify.instructions.header = To use Shopify with SOS Inventory, follow these steps. If you run into any problems, contact support@sosinventory.com for assistance.

Shopify.instructions.1 = Enter your Shopify shop name (e.g., shopname.myshopify.com), cart name, and select a location.

Shopify.instructions.connector.2 = Click the "Connect to Shopify" button below to begin the authorization process.
Shopify.instructions.connector.2.1 = You will be redirected to Shopify to approve SOS Inventory's access to your store.
Shopify.instructions.connector.2.2 = Review the permissions that SOS Inventory is requesting. These include: read customers, read/write inventory, read locations, read orders, read/write product listings, and read/write products.
Shopify.instructions.connector.2.3 = Click "Install" to grant access.
Shopify.instructions.connector.2.4 = Once you click "Install," you will be redirected back to SOS Inventory where the connection will be completed, and then you will be taken to the carts list.

Shopify.instructions.private.2 = Follow the steps below in Shopify. Once completed, enter the API key and password in the designated form fields.
Shopify.instructions.private.2.1 = From your Shopify admin, click Apps.
Shopify.instructions.private.2.2 = Click Manage private apps.
Shopify.instructions.private.2.3 = Click Create new private app.
Shopify.instructions.private.2.4 = In the Description section, enter SOS Inventory.
Shopify.instructions.private.2.5 = In the Admin API section, make sure that you set "Read and write" on the following permissions: "Customer details and customer groups", "Fulfillment services", "Inventory", "Orders, transactions and fulfillments", and "Products, variants, and collections." You might have to expand the "Review disabled Admin API permissions" section to set some of these permissions.
Shopify.instructions.private.2.6 = When you're done, click Save. The API key and password for your application are now displayed on screen.

Shopify.instructions.custom.2 = Follow the steps below in Shopify. Once completed, enter the Admin API access token in the designated form field.
Shopify.instructions.custom.2.1 = From your Shopify admin, click Settings and then choose Apps and Sales Channels.
Shopify.instructions.custom.2.2 = Click on Develop apps for your store or Developer Apps.
Shopify.instructions.custom.2.3 = Click on Create an app button.
Shopify.instructions.custom.2.4 = Enter SOS Inventory in the App Name field and click Create App.
Shopify.instructions.custom.2.5 = Click on Configuration. Then, in the Admin API Integration section, click Configure and enable the following permissions: read customers, write/read inventory, read locations, read orders, write/read product listings, write/read products. In the Webhook subscriptions field, choose the latest connection. Now go to the top of this page and click Save.
Shopify.instructions.custom.2.6 = Click on the API credentials tab and view the Admin API access token. Copy this and paste this into the designated field.
Shopify.instructions.custom.2.6.note = Note: Be sure to store this Admin API access token to a safe place as it can only be viewed once.

Shopify.instructions.appcreds.2 = Follow the steps below in Shopify. Once completed, enter the Client ID and Client Secret in the fields to the left.
Shopify.instructions.appcreds.2.1 = Log in to Shopify at https://accounts.shopify.com/
Shopify.instructions.appcreds.2.2 = In the lower left corner, click Settings.
Shopify.instructions.appcreds.2.3 = On the left column menu options, click Apps.
Shopify.instructions.appcreds.2.4 = Click Develop Apps. If prompted, click Allow custom app development.
Shopify.instructions.appcreds.2.5 = Click "Build apps in Dev Dashboard." This will open a new tab in your browser.
Shopify.instructions.appcreds.2.6 = In the new tab, click "Create app."
Shopify.instructions.appcreds.2.7 = Under "Start from Dev Dashboard," enter an App Name of "SOS Inventory" and click Create.
Shopify.instructions.appcreds.2.8 = Set App URL = https://app.sosinventory.com/ and Webhooks API version = Latest available option.
Shopify.instructions.appcreds.2.9 = Under the Access Section, in the Scopes box, select: read_customers, write_inventory, read_inventory, read_locations, read_orders, read_product_listings, write_product_listings, read_products, write_products.
Shopify.instructions.appcreds.2.10 = Click Release at the bottom right. A version name and version message are not necessary. Click Release again on the popup.
Shopify.instructions.appcreds.2.11 = On the left side of the page, click Settings. Copy the Client ID and Client Secret and paste them into the fields to the left.

Shopify.instructions.3 = Configure any other settings on this page as needed and then click 'Save and Close.'

Shopify.instructions.4.1 = That's it. SOS Inventory is connected to Shopify. Shopify orders will post to SOS Inventory, and inventory data will flow back to Shopify. Refer to the  V9 User Guide in the 
Shopify.instructions.4.2 = if you need detailed information about how SOS communicates with Shopify (item mapping, etc.).
Shopify.instructions.note = Note: Customer Information is not sent on orders from Shopify if you subscribe to Shopify Basic.

BigCommerce.instructions.header = To use BigCommerce with SOS Inventory, follow these steps. If you run into any problems, contact support@sosinventory.com for assistance.
BigCommerce.instructions.1 = Follow the steps below in BigCommerce. Once completed, enter the client ID and access token in the designated form fields.

BigCommerce.instructions.1.1 = From your BigCommerce admin page, click Settings.
BigCommerce.instructions.1.2 = Scroll down to the API section and click on Store-level API Accounts.
BigCommerce.instructions.1.3 = Click Create API Account.
BigCommerce.instructions.1.4 = In the Name section, enter SOS Inventory.
BigCommerce.instructions.1.5 = Copy the "API Path" into the designated field.
BigCommerce.instructions.1.6 = In the OAuth Scopes section, make sure that you set "modify" on the following permissions: "Customers", "Orders", and "Products."
BigCommerce.instructions.1.7 = When you're done, click Save. The client ID and access token for your application are now displayed on screen. Enter them in the designated fields.

BigCommerce.instructions.2 = Configure any other settings on this page as needed and then click 'Save and Close.' The 'Save and Close' action will cause SOS to begin matching your SOS items to your BigCommerce items. If you later add more items, just come back to this page and 'Save and Close' to have SOS match the new items.

BigCommerce.instructions.3.1 = SOS Inventory is connected to BigCommerce. BigCommerce orders will post to SOS Inventory, and inventory data will flow back to BigCommerce. Refer to the  V9 User Guide in the 
BigCommerce.instructions.3.2 = if you need detailed information about how SOS communicates with BigCommerce (item mapping, etc.).

PayPal.instructions.header = To use PayPal with SOS Inventory, follow these steps. If you run into any problems, contact support@sosinventory.com for assistance.
PayPal.instructions.1 = Follow the steps below in PayPal. Once completed, complete the form and save.

PayPal.instructions.1.1.1 = Go to the
PayPal.instructions.1.1.2 = PayPal website
PayPal.instructions.1.1.3 = and login to your account.

PayPal.instructions.1.2 = Choose the settings icon (Gear).
PayPal.instructions.1.3 = Click the "Seller Tools" submenu link.
PayPal.instructions.1.4 = Click the "Instant payment notifications" line.
PayPal.instructions.1.5 = Click the button that says "Choose IPN Settings."
PayPal.instructions.1.6 = In the Notification URL box, enter the following URL: https://paypal.sosinventory.com/callbacks/ipn.aspx
PayPal.instructions.1.7 = Choose the option that says "Receive IPN messages (Enabled)." Your screen should look like the image below.
PayPal.instructions.1.8 = Click the "Save" button on the PayPal screen.

PayPal.instructions.2 = Enter your PayPal address in the designated field. Configure any other settings on this page as needed and then click "Save and Close."

PayPal.instructions.3.1 = SOS Inventory is connected to PayPal. PayPal orders will now post to SOS Inventory. Refer to the V9 User Guide in the 
PayPal.instructions.3.2 = if you need detailed information about how SOS communicates with PayPal.

depositAccount.hoverHelp = Funds from sales receipts will post to this account in QuickBooks.
incomeAccount.hoverHelp = Income account for PayPal payments.
feeAccount.hoverHelp = Expense account for PayPal fees.


[password]
RequestReset = Request reset
ChangePassword = Change password
Forgot.title = Password recovery
Reset.title = Reset your SOS Inventory password
Recover.title = SOS Inventory password recovery
GoBackToLogin = Go back to the SOS Inventory login page
ForgotPasswordSubmitMessage = If an account exists for the email you entered, you will receive an email with instructions to reset your password. Please check your inbox and spam folder.
ResetPasswordSubmitMessage = Your password has been reset successfully.
ResetPasswordDefaultError = Error resetting password
IForgotMyPassword = I forgot my password

[errorCode]
QUANTITY_ON_HAND_NOT_ZERO = The following items were not deleted because they had non-zero quantity on hand:
BIN_HAS_CONTENTS = No bins were deleted because the following bins contain items: {{binList}}
NAME_VALUE_REQUIRED = A name is required. Please enter a value to continue.
DUPLICATE_NAME = This name is already in use. Please choose a different name.
OVER_DEPARTMENT_CLASS_LIMIT_ZERO = You've reached the maximum number allowed by your QuickBooks plan (limit: {{limit}}). To add a new one, you'll need to upgrade your QuickBooks plan.
OVER_DEPARTMENT_CLASS_LIMIT_OVER_ZERO = You've reached the maximum number allowed by your QuickBooks plan (limit: {{limit}}). To add a new one, you'll need to remove an existing entry or upgrade your QuickBooks plan.
LOCATION_QUANTITY_ON_HAND_NOT_ZERO = This location cannot be deleted because it contains inventory. The following items have non-zero quantities on hand:
WARRANTY_IS_ASSIGNED = This warranty cannot be deleted because it is currently assigned to one or more {{type}}. Please remove the warranty from the following {{type}} before deleting:
WARRANTY_IS_ASSIGNED_MORE = This warranty cannot be deleted because it is currently assigned to one or more {{type}}. Please remove the warranty from the following {{type}} before deleting (showing first 10 of {{more}}):
WARRANTY_TYPE_ITEM = items
WARRANTY_TYPE_SERIAL = serial numbers

[supportConsole]
isValid.companyId = 
isValid.user = 

[concurrency]
SaveConflict = A conflict occurred while saving
ConflictMessage = We found a newer version of this {{objectType}} in the system, created by someone else, or a system process, while you were editing. You can either OVERWRITE the newer version with your changes, or DISCARD your edits and refresh this page with the newer version.
Discard = Discard
Overwrite = Overwrite

`.trim();
